import React from "react";

const CarIllustrationFuelTriage = ({ isMobile = true }) => {
  return isMobile ? (
    <svg
      width="100%"
      height="203"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* <mask
        id="mask0_10322_1855"
        style="mask-type:luminance"
        maskUnits="userSpaceOnUse"
        x="-474"
        y="0"
        width="1298"
        height="197"
      >
        <rect x="-474" width="1298" height="197" fill="white" />
      </mask> */}
      <g mask="url(#mask0_10322_1855)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M230.472 109.992C230.472 157.103 169.682 195.294 94.6945 195.294C19.7066 195.294 -41.0826 157.103 -41.0826 109.992C-41.0826 62.8807 19.7066 24.6899 94.6945 24.6899C169.682 24.6899 230.472 62.8807 230.472 109.992Z"
          fill="#E5F0FA"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M-149.988 196.533L468.838 197.366L422.968 118.241L-4.03833 89.37L-153.665 134.296L-149.988 196.533Z"
          fill="#E5F0FA"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M383.698 156.276C383.698 232.121 312.025 293.605 223.612 293.605C135.199 293.605 63.5255 232.121 63.5255 156.276C63.5255 80.4319 135.199 18.9474 223.612 18.9474C312.025 18.9474 383.698 80.4319 383.698 156.276Z"
          fill="#E5F0FA"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M517.173 263.651C494.85 337.706 416.44 367.765 342.039 330.79C267.638 293.816 225.42 203.809 247.742 129.754C270.065 55.6996 348.476 25.6402 422.877 62.615C497.278 99.5893 539.495 189.596 517.173 263.651Z"
          fill="#E5F0FA"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M165.112 153.265C165.112 234.08 89.225 299.594 -4.38591 299.594C-97.9968 299.594 -173.884 234.08 -173.884 153.265C-173.884 72.4502 -97.9968 6.93688 -4.38591 6.93688C89.225 6.93688 165.112 72.4502 165.112 153.265Z"
          fill="#E5F0FA"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M185.698 118.968C185.698 155.605 159 185.303 126.066 185.303C93.1324 185.303 66.4342 155.605 66.4342 118.968C66.4342 82.3324 93.1324 52.6333 126.066 52.6333C159 52.6333 185.698 82.3324 185.698 118.968Z"
          fill="#E5F0FA"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M167.83 140.149C167.83 140.149 140.908 108.655 88.8103 108.655C88.8103 108.655 47.5453 109.643 28.4927 97.4911C28.4927 97.4911 7.34308 82.6126 -24.4751 93.5141C-24.4751 93.5141 -73.0757 115.318 -95.803 108.958C-95.803 108.958 -207.69 84.1263 -250.346 107.141C-250.346 107.141 -326.222 121.962 -408.039 122.568C-408.039 122.568 -475.168 120.7 -474.12 197.635L183.914 197.03L167.83 142.572"
          fill="#E5F0FA"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M822.632 197.122C829.346 143.862 818.717 112.576 788.857 87.3049C732.132 39.3001 585.525 23.5546 483.6 46.8025C381.677 70.0511 353.094 125.877 419.758 171.494L435.891 196.94L822.632 197.122Z"
          fill="#E5F0FA"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M151.785 149.579L124.846 144.101C124.293 143.992 123.729 143.945 123.165 143.96V140.094H128.916C129.169 140.117 129.413 139.996 129.546 139.781C129.68 139.565 129.68 139.292 129.546 139.077C129.413 138.861 129.169 138.74 128.916 138.764H123.212V137.762H130.773C131.025 137.786 131.269 137.664 131.403 137.449C131.536 137.233 131.536 136.961 131.403 136.745C131.269 136.53 131.025 136.408 130.773 136.432H123.212V134.932H129.537C129.789 134.956 130.033 134.835 130.167 134.619C130.3 134.404 130.3 134.131 130.167 133.916C130.033 133.7 129.789 133.579 129.537 133.602H123.212V131.939H128.635C128.887 131.962 129.132 131.841 129.265 131.625C129.399 131.41 129.399 131.137 129.265 130.922C129.132 130.706 128.887 130.585 128.635 130.609H123.212V129.455H126.826C127.078 129.478 127.322 129.357 127.456 129.141C127.589 128.926 127.589 128.653 127.456 128.438C127.322 128.222 127.078 128.101 126.826 128.125H123.212V126.953H128.483C128.735 126.977 128.979 126.855 129.113 126.64C129.246 126.424 129.246 126.152 129.113 125.936C128.979 125.721 128.735 125.599 128.483 125.623H123.212V123.93H127.154C127.406 123.954 127.65 123.832 127.783 123.617C127.917 123.401 127.917 123.129 127.783 122.913C127.65 122.698 127.406 122.576 127.154 122.6H123.212V120.778H125.918C126.17 120.802 126.414 120.68 126.548 120.465C126.681 120.249 126.681 119.977 126.548 119.761C126.414 119.546 126.17 119.424 125.918 119.448H123.212V118.106H126.826C127.078 118.13 127.322 118.009 127.456 117.793C127.589 117.578 127.589 117.305 127.456 117.09C127.322 116.874 127.078 116.753 126.826 116.777H123.212V115.113H126.41C126.662 115.136 126.906 115.015 127.04 114.8C127.173 114.584 127.173 114.311 127.04 114.096C126.906 113.88 126.662 113.759 126.41 113.783H123.212V111.955H123.798C124.05 111.979 124.294 111.857 124.428 111.642C124.561 111.426 124.561 111.154 124.428 110.938C124.294 110.723 124.05 110.601 123.798 110.625H123.212V109.453H124.518C124.861 109.421 125.123 109.133 125.123 108.788C125.123 108.444 124.861 108.156 124.518 108.123H123.212V106.448C123.554 106.404 123.805 106.106 123.789 105.762C123.774 105.418 123.498 105.143 123.154 105.13H121.936C121.592 105.145 121.318 105.421 121.304 105.765C121.291 106.108 121.542 106.405 121.883 106.448V108.123H120.284C120.032 108.1 119.788 108.221 119.654 108.437C119.521 108.652 119.521 108.925 119.654 109.14C119.788 109.356 120.032 109.477 120.284 109.453H121.842V110.625H120.536C120.284 110.601 120.04 110.723 119.906 110.938C119.773 111.154 119.773 111.426 119.906 111.642C120.04 111.857 120.284 111.979 120.536 111.955H121.848V113.783H118.65C118.398 113.759 118.154 113.88 118.02 114.096C117.887 114.311 117.887 114.584 118.02 114.8C118.154 115.015 118.398 115.136 118.65 115.113H121.854V116.777H117.503C117.25 116.753 117.006 116.874 116.873 117.09C116.739 117.305 116.739 117.578 116.873 117.793C117.006 118.009 117.25 118.13 117.503 118.106H121.86V119.448H118.662C118.41 119.424 118.166 119.546 118.032 119.761C117.899 119.977 117.899 120.249 118.032 120.465C118.166 120.68 118.41 120.802 118.662 120.778H121.865V122.6H117.356C117.104 122.576 116.86 122.698 116.726 122.913C116.593 123.129 116.593 123.401 116.726 123.617C116.86 123.832 117.104 123.954 117.356 123.93H121.877V125.594H115.787C115.534 125.57 115.29 125.691 115.157 125.907C115.023 126.122 115.023 126.395 115.157 126.611C115.29 126.826 115.534 126.947 115.787 126.924H121.865V128.095H117.432C117.18 128.072 116.936 128.193 116.802 128.408C116.669 128.624 116.669 128.897 116.802 129.112C116.936 129.328 117.18 129.449 117.432 129.425H121.871V130.597H114.727C114.474 130.573 114.23 130.695 114.097 130.91C113.963 131.126 113.963 131.398 114.097 131.614C114.23 131.829 114.474 131.951 114.727 131.927H121.877V133.591H114.961C114.709 133.567 114.465 133.688 114.331 133.904C114.198 134.119 114.198 134.392 114.331 134.607C114.465 134.823 114.709 134.944 114.961 134.921H121.865V136.42H112.414C112.161 136.397 111.917 136.518 111.784 136.734C111.65 136.949 111.65 137.222 111.784 137.437C111.917 137.653 112.161 137.774 112.414 137.75H121.865V138.764H115.131C114.878 138.74 114.634 138.861 114.501 139.077C114.367 139.292 114.367 139.565 114.501 139.781C114.634 139.996 114.878 140.117 115.131 140.094H121.871V144.007L104.637 144.781V134.013C108.121 133.298 110.774 129.654 110.774 125.254C110.774 120.344 107.471 116.361 103.395 116.361C99.3192 116.361 96.0163 120.344 96.0163 125.254C96.0163 129.847 98.9034 133.626 102.61 134.095V144.886L95.5478 145.202C94.5324 145.247 93.5365 145.496 92.6197 145.935L89.4515 147.452C87.6947 143.439 82.9512 139.467 76.6382 137.276C74.6396 136.591 72.5716 136.129 70.4717 135.899V132.683H78.0847C78.5699 132.683 78.9632 132.289 78.9632 131.804C78.9632 131.318 78.5699 130.925 78.0847 130.925H70.4717V129.589H80.4272C80.9123 129.602 81.3161 129.219 81.329 128.734C81.342 128.249 80.9592 127.845 80.474 127.832H70.4717V125.852H78.8167C79.3019 125.852 79.6952 125.458 79.6952 124.973C79.6952 124.487 79.3019 124.094 78.8167 124.094H70.4717V121.903H77.6221C77.9359 121.911 78.2304 121.751 78.3945 121.484C78.5587 121.216 78.5676 120.881 78.418 120.605C78.2683 120.329 77.9828 120.154 77.6689 120.145H70.4717V118.593H75.2386C75.7238 118.606 76.1275 118.223 76.1405 117.737C76.1534 117.252 75.7706 116.848 75.2855 116.835H70.4776V115.283H77.4113C77.8964 115.296 78.3002 114.913 78.3131 114.427C78.326 113.942 77.9433 113.538 77.4581 113.525H70.4717V111.334H75.672C75.9858 111.334 76.2758 111.166 76.4327 110.895C76.5897 110.623 76.5897 110.288 76.4327 110.016C76.2758 109.744 75.9858 109.576 75.672 109.576H70.4717V107.192H74.0205C74.5057 107.205 74.9095 106.822 74.9224 106.337C74.9353 105.851 74.5526 105.447 74.0674 105.434H70.4541V103.677H75.2211C75.7062 103.69 76.11 103.307 76.1229 102.821C76.1359 102.336 75.7531 101.932 75.2679 101.919H70.46V99.7046H74.6823C75.1674 99.7176 75.5712 99.3346 75.5841 98.8493C75.5971 98.3639 75.2143 97.96 74.7292 97.9471H70.46V95.5392H71.2096C71.6947 95.5392 72.088 95.1457 72.088 94.6604C72.088 94.1751 71.6947 93.7816 71.2096 93.7816H70.46V92.2291H72.1876C72.6727 92.2291 73.066 91.8356 73.066 91.3503C73.066 90.865 72.6727 90.4715 72.1876 90.4715H70.46V88.2745C70.9451 88.2535 71.3214 87.843 71.3004 87.3577C71.2793 86.8723 70.869 86.4959 70.3839 86.517H68.7734C68.2883 86.4959 67.878 86.8723 67.8569 87.3577C67.8359 87.843 68.2122 88.2535 68.6973 88.2745V90.4774H66.6476C66.1625 90.4774 65.7692 90.8708 65.7692 91.3562C65.7692 91.8415 66.1625 92.2349 66.6476 92.2349H68.6973V93.7875H66.9932C66.508 93.7745 66.1042 94.1575 66.0913 94.6428C66.0784 95.1282 66.4612 95.5321 66.9463 95.545H68.7032V97.9529H64.4809C63.9957 97.9529 63.6024 98.3464 63.6024 98.8317C63.6024 99.3171 63.9957 99.7105 64.4809 99.7105H68.7032V101.919H62.9641C62.479 101.906 62.0752 102.289 62.0623 102.775C62.0493 103.26 62.4321 103.664 62.9173 103.677H68.7032V105.434H64.4809C63.9957 105.421 63.5919 105.804 63.579 106.29C63.5661 106.775 63.9489 107.179 64.434 107.192H68.7032V109.6H62.7592C62.274 109.6 61.8807 109.993 61.8807 110.479C61.8807 110.964 62.274 111.357 62.7592 111.357H68.7149V113.548H60.6978C60.2126 113.536 59.8089 113.918 59.7959 114.404C59.783 114.889 60.1658 115.293 60.6509 115.306H68.7149V116.859H62.8938C62.4087 116.846 62.0049 117.229 61.992 117.714C61.979 118.199 62.3618 118.603 62.847 118.616H68.7441V120.169H59.3157C58.8306 120.169 58.4373 120.562 58.4373 121.047C58.4373 121.533 58.8306 121.926 59.3157 121.926H68.7441V124.117H59.6144C59.1292 124.117 58.736 124.511 58.736 124.996C58.736 125.481 59.1292 125.875 59.6144 125.875H68.7207V127.855H56.2471C55.8961 127.858 55.5802 128.069 55.4439 128.393C55.3076 128.716 55.3771 129.09 55.6205 129.343H47.5683V127.34H55.9133C56.3984 127.34 56.7917 126.946 56.7917 126.461C56.7917 125.975 56.3984 125.582 55.9133 125.582H47.5683V123.391H54.6952C55.1804 123.391 55.5736 122.997 55.5736 122.512C55.5736 122.027 55.1804 121.633 54.6952 121.633H47.5683V120.081H52.3528C52.8379 120.081 53.2312 119.687 53.2312 119.202C53.2312 118.717 52.8379 118.323 52.3528 118.323H47.5858V116.777H54.5195C55.0047 116.777 55.3979 116.383 55.3979 115.898C55.3979 115.412 55.0047 115.019 54.5195 115.019H47.5683V112.828H52.7685C53.0824 112.836 53.3768 112.676 53.541 112.409C53.7051 112.141 53.7141 111.806 53.5644 111.53C53.4147 111.254 53.1292 111.079 52.8154 111.07H47.5448V108.662H51.1171C51.6022 108.675 52.006 108.292 52.019 107.807C52.0319 107.322 51.6491 106.918 51.1639 106.905H47.5507V105.147H52.3528C52.8379 105.147 53.2312 104.754 53.2312 104.268C53.2312 103.783 52.8379 103.39 52.3528 103.39H47.5858V101.193H51.7671C52.2523 101.193 52.6455 100.799 52.6455 100.314C52.6455 99.8286 52.2523 99.4352 51.7671 99.4352H47.5448V97.0273H48.2944C48.7796 97.0402 49.1833 96.6573 49.1963 96.1719C49.2092 95.6866 48.8264 95.2826 48.3413 95.2697H47.5448V93.7172H49.2724C49.7575 93.7301 50.1613 93.3472 50.1743 92.8618C50.1872 92.3765 49.8044 91.9725 49.3192 91.9596H47.5624V89.7626C48.0475 89.7416 48.4238 89.3311 48.4028 88.8458C48.3817 88.3604 47.9714 87.984 47.4863 88.005H45.9109C45.4258 87.984 45.0155 88.3604 44.9945 88.8458C44.9734 89.3311 45.3497 89.7416 45.8348 89.7626V91.9596H43.7852C43.3 91.9467 42.8963 92.3296 42.8833 92.8149C42.8704 93.3003 43.2532 93.7042 43.7383 93.7172H45.8348V95.2697H44.1073C43.6221 95.2568 43.2184 95.6397 43.2054 96.125C43.1925 96.6104 43.5753 97.0143 44.0604 97.0273H45.8173V99.4352H41.595C41.1098 99.4222 40.7061 99.8052 40.6931 100.291C40.6802 100.776 41.063 101.18 41.5481 101.193H45.8173V103.384H40.0548C39.5697 103.384 39.1764 103.777 39.1764 104.263C39.1764 104.748 39.5697 105.141 40.0548 105.141H45.7938V106.899H41.5715C41.0864 106.886 40.6826 107.269 40.6697 107.754C40.6568 108.24 41.0396 108.644 41.5247 108.657H45.7938V111.064H39.8557C39.3705 111.052 38.9668 111.434 38.9538 111.92C38.9409 112.405 39.3237 112.809 39.8088 112.822H45.8114V115.013H37.7943C37.3092 115.013 36.9159 115.407 36.9159 115.892C36.9159 116.377 37.3092 116.771 37.7943 116.771H45.8114V118.323H39.9552C39.4701 118.323 39.0768 118.717 39.0768 119.202C39.0768 119.687 39.4701 120.081 39.9552 120.081H45.8114V121.633H36.383C35.8979 121.633 35.5045 122.027 35.5045 122.512C35.5045 122.997 35.8979 123.391 36.383 123.391H45.8114V125.588H36.7051C36.2199 125.588 35.8267 125.981 35.8267 126.467C35.8267 126.952 36.2199 127.345 36.7051 127.345H45.8114V129.326H33.3436C32.8585 129.326 32.4652 129.719 32.4652 130.204C32.4652 130.69 32.8585 131.083 33.3436 131.083H45.8114V132.425H37.4078L21.3151 128.505L17.8834 126.971C16.4603 121.838 11.3596 118.001 5.30432 118.001C4.04193 118 2.78522 118.17 1.56808 118.505V110.121L6.14758 109.125L7.40668 105.669C8.23596 105.876 9.11154 105.789 9.88385 105.423C11.4091 104.639 12.2451 102.952 11.9452 101.263C12.3149 101.211 12.6744 101.102 13.011 100.941C14.9715 99.9126 15.7289 97.49 14.7035 95.5275C14.4705 95.0438 14.151 94.607 13.7606 94.2386C14.0267 93.6741 14.1666 93.0583 14.1705 92.4341C14.1705 90.0087 12.1033 87.9758 9.3158 87.4016C8.43152 84.9293 6.32916 83.1717 3.88715 83.1717C2.52396 83.1836 1.2168 83.7159 0.23288 84.6598C-0.996918 83.1717 -3.3511 82.7499 -5.44174 83.7576C-6.6015 84.2965 -7.52274 85.2431 -8.03015 86.4174C-11.8133 86.6576 -14.794 89.2354 -14.794 92.3931C-14.7952 92.9933 -14.6881 93.5887 -14.4778 94.1507C-14.8372 94.2037 -15.1866 94.3103 -15.5143 94.4671C-17.334 95.5847 -18.0117 97.8994 -17.0823 99.8226C-16.1529 101.746 -13.9185 102.652 -11.9128 101.919L-11.743 101.825C-11.7515 102.501 -11.6031 103.168 -11.3096 103.776C-10.5757 105.379 -8.90561 106.339 -7.15173 106.167L-5.32462 109.682L-0.692383 111.609V117.737C-2.11169 117.293 -3.56497 116.966 -5.03766 116.759C-6.60477 116.169 -8.30911 116.045 -9.94513 116.402C-12.5744 116.383 -15.2008 116.579 -17.7982 116.987C-21.0771 117.482 -24.2945 118.323 -27.3965 119.495C-27.222 119.142 -27.2928 118.717 -27.5722 118.44C-27.7449 118.268 -27.9785 118.172 -28.2222 118.171H-35.765V116.566H-25.8095C-25.4624 116.593 -25.1292 116.424 -24.9472 116.127C-24.7652 115.83 -24.7652 115.456 -24.9472 115.159C-25.1292 114.862 -25.4624 114.693 -25.8095 114.72H-35.765V112.465H-27.4668C-27.1197 112.492 -26.7865 112.323 -26.6045 112.026C-26.4225 111.729 -26.4225 111.355 -26.6045 111.058C-26.7865 110.761 -27.1197 110.592 -27.4668 110.619H-35.765V108.1H-28.6614C-28.3144 108.128 -27.9811 107.958 -27.7991 107.661C-27.6171 107.364 -27.6171 106.99 -27.7991 106.693C-27.9811 106.396 -28.3144 106.227 -28.6614 106.255H-35.765V104.731H-32.2513C-31.9889 104.731 -31.7393 104.618 -31.5661 104.421H-31.0566C-30.7095 104.448 -30.3763 104.279 -30.1943 103.982C-30.0123 103.685 -30.0123 103.311 -30.1943 103.014C-30.3763 102.717 -30.7095 102.548 -31.0566 102.575H-35.7767V100.818H-31.0566C-30.9321 100.819 -30.8086 100.795 -30.6935 100.747H-28.884C-28.5369 100.775 -28.2037 100.606 -28.0217 100.309C-27.8396 100.012 -27.8396 99.6377 -28.0217 99.3408C-28.2037 99.0439 -28.5369 98.8743 -28.884 98.902H-35.765V96.4707H-31.5895C-31.2425 96.4984 -30.9092 96.3288 -30.7272 96.0319C-30.5452 95.735 -30.5452 95.361 -30.7272 95.0641C-30.9092 94.7671 -31.2425 94.5976 -31.5895 94.6253H-35.7708V91.8717H-35.0681C-34.721 91.8994 -34.3878 91.7298 -34.2057 91.4329C-34.0237 91.136 -34.0237 90.762 -34.2057 90.4651C-34.3878 90.1681 -34.721 89.9986 -35.0681 90.0263H-35.7767V88.2101H-34.0959C-33.7489 88.2378 -33.4156 88.0682 -33.2336 87.7713C-33.0516 87.4744 -33.0516 87.1004 -33.2336 86.8034C-33.4156 86.5065 -33.7489 86.337 -34.0959 86.3646H-35.7825V83.8337C-35.295 83.779 -34.9363 83.3509 -34.9676 82.861C-34.9989 82.3712 -35.4091 81.9922 -35.8997 82H-37.5101C-38.0007 81.9922 -38.4109 82.3712 -38.4422 82.861C-38.4735 83.3509 -38.1148 83.779 -37.6272 83.8337V86.3646H-39.6359C-39.983 86.337 -40.3162 86.5065 -40.4982 86.8034C-40.6802 87.1004 -40.6802 87.4744 -40.4982 87.7713C-40.3162 88.0682 -39.983 88.2378 -39.6359 88.2101H-37.6272V90.0263H-39.2962C-39.6433 89.9986 -39.9765 90.1681 -40.1585 90.4651C-40.3405 90.762 -40.3405 91.136 -40.1585 91.4329C-39.9765 91.7298 -39.6433 91.8994 -39.2962 91.8717H-37.6096V94.6311H-41.7851C-42.1322 94.6034 -42.4654 94.773 -42.6474 95.0699C-42.8294 95.3668 -42.8294 95.7408 -42.6474 96.0378C-42.4654 96.3347 -42.1322 96.5043 -41.7851 96.4766H-37.6038V98.9255H-45.5858C-45.9328 98.8978 -46.2661 99.0673 -46.4481 99.3643C-46.6301 99.6612 -46.6301 100.035 -46.4481 100.332C-46.2661 100.629 -45.9328 100.799 -45.5858 100.771H-43.6884C-43.5738 100.821 -43.4502 100.847 -43.3253 100.847H-37.6331V102.605H-43.4365C-43.9459 102.592 -44.3694 102.994 -44.3823 103.504C-44.3952 104.014 -43.9928 104.437 -43.4834 104.45H-42.4937C-42.32 104.647 -42.0707 104.76 -41.8085 104.761H-37.6331V106.266H-47.0029C-47.5117 106.266 -47.925 106.677 -47.9282 107.186C-47.9341 107.398 -47.8658 107.605 -47.735 107.772C-48.9055 106.608 -50.4829 105.946 -52.1329 105.926C-52.4073 105.927 -52.6812 105.947 -52.9528 105.985C-52.9934 105.289 -53.1938 104.611 -53.5384 104.005C-55.2133 101.076 -59.8572 100.003 -63.9097 101.661C-66.9666 102.903 -68.8113 105.329 -68.823 107.707C-72.0732 109.039 -74.1812 112.22 -74.1404 115.734C-74.1404 120.18 -70.9839 123.842 -66.9432 124.276L-64.3782 128.464L-60.1676 129.953V132.085C-62.8666 132.426 -65.5393 132.951 -68.1671 133.655C-78.1226 136.315 -86.0753 141.019 -88.9331 145.495C-92.544 144.3 -96.3267 143.706 -100.13 143.738C-104.708 143.663 -109.25 144.549 -113.465 146.339V143.468H-105.852C-105.366 143.481 -104.963 143.098 -104.95 142.613C-104.937 142.128 -105.32 141.724 -105.805 141.711H-113.418V140.375H-103.462C-102.977 140.375 -102.584 139.981 -102.584 139.496C-102.584 139.011 -102.977 138.617 -103.462 138.617H-113.418V136.643H-105.12C-104.634 136.643 -104.241 136.25 -104.241 135.764C-104.241 135.279 -104.634 134.885 -105.12 134.885H-113.465V132.694H-106.314C-105.829 132.707 -105.425 132.324 -105.412 131.839C-105.399 131.354 -105.782 130.95 -106.267 130.937H-113.465V129.384H-108.692C-108.207 129.384 -107.813 128.991 -107.813 128.505C-107.813 128.02 -108.207 127.627 -108.692 127.627H-113.453V126.074H-106.519C-106.034 126.074 -105.641 125.681 -105.641 125.195C-105.641 124.71 -106.034 124.317 -106.519 124.317H-113.465V122.125H-108.264C-107.779 122.125 -107.386 121.732 -107.386 121.247C-107.386 120.761 -107.779 120.368 -108.264 120.368H-113.465V117.96H-109.863C-109.378 117.96 -108.985 117.567 -108.985 117.081C-108.985 116.596 -109.378 116.202 -109.863 116.202H-113.435V114.445H-108.692C-108.207 114.445 -107.813 114.051 -107.813 113.566C-107.813 113.081 -108.207 112.687 -108.692 112.687H-113.453V110.766C-113.23 110.754 -113.021 110.657 -112.867 110.496H-109.213C-108.899 110.496 -108.609 110.329 -108.452 110.057C-108.295 109.785 -108.295 109.45 -108.452 109.178C-108.609 108.906 -108.899 108.739 -109.213 108.739H-113.435V106.331H-112.686C-112.201 106.331 -111.807 105.937 -111.807 105.452C-111.807 104.967 -112.201 104.573 -112.686 104.573H-113.435V103.021H-111.708C-111.223 103.021 -110.829 102.627 -110.829 102.142C-110.829 101.656 -111.223 101.263 -111.708 101.263H-113.435V99.5758C-113.435 99.0904 -113.829 98.697 -114.314 98.697C-114.799 98.697 -115.192 99.0904 -115.192 99.5758V101.263H-117.242C-117.727 101.263 -118.12 101.656 -118.12 102.142C-118.12 102.627 -117.727 103.021 -117.242 103.021H-115.192V104.573H-116.92C-117.405 104.573 -117.798 104.967 -117.798 105.452C-117.798 105.937 -117.405 106.331 -116.92 106.331H-115.192V108.739H-119.414C-119.9 108.726 -120.303 109.109 -120.316 109.594C-120.329 110.079 -119.946 110.483 -119.461 110.496H-115.76C-115.607 110.657 -115.397 110.754 -115.175 110.766V112.687H-120.914C-121.399 112.687 -121.792 113.081 -121.792 113.566C-121.792 114.051 -121.399 114.445 -120.914 114.445H-115.175V116.202H-119.397C-119.882 116.202 -120.275 116.596 -120.275 117.081C-120.275 117.567 -119.882 117.96 -119.397 117.96H-115.175V120.368H-121.177C-121.662 120.368 -122.056 120.761 -122.056 121.247C-122.056 121.732 -121.662 122.125 -121.177 122.125H-115.221V124.317H-123.238C-123.724 124.317 -124.117 124.71 -124.117 125.195C-124.117 125.681 -123.724 126.074 -123.238 126.074H-115.221V127.627H-121.078C-121.563 127.627 -121.956 128.02 -121.956 128.505C-121.956 128.991 -121.563 129.384 -121.078 129.384H-115.221V130.937H-124.65C-125.135 130.937 -125.528 131.33 -125.528 131.816C-125.528 132.301 -125.135 132.694 -124.65 132.694H-115.221V134.885H-124.322C-124.807 134.873 -125.211 135.255 -125.224 135.741C-125.237 136.226 -124.854 136.63 -124.369 136.643H-115.221V138.623H-127.689C-128.174 138.623 -128.568 139.017 -128.568 139.502C-128.568 139.987 -128.174 140.381 -127.689 140.381H-115.221V141.722H-124.105C-124.59 141.709 -124.994 142.092 -125.007 142.578C-125.02 143.063 -124.637 143.467 -124.152 143.48H-115.221V147.265C-115.663 147.522 -116.078 147.792 -116.469 148.073L-130.992 146.316C-133.242 146.04 -135.509 146.657 -137.311 148.032V139.145C-133.288 138.319 -130.225 134.141 -130.225 129.039C-130.225 123.373 -134.037 118.78 -138.74 118.78C-143.442 118.78 -147.255 123.373 -147.255 129.039C-147.255 134.311 -143.922 138.694 -139.642 139.238V150.171L-141.27 151.717C-144.435 149.921 -148.314 149.933 -151.469 151.748C-154.623 153.564 -156.584 156.911 -156.624 160.552C-158.441 159.892 -160.447 160 -162.182 160.851V155.502H-156.127C-155.642 155.502 -155.248 155.108 -155.248 154.623C-155.248 154.138 -155.642 153.744 -156.127 153.744H-162.182V152.959H-154.159C-153.674 152.959 -153.281 152.566 -153.281 152.08C-153.281 151.595 -153.674 151.202 -154.159 151.202H-162.182V149.895H-155.494C-155.009 149.895 -154.616 149.502 -154.616 149.016C-154.616 148.531 -155.009 148.138 -155.494 148.138H-162.182V146.655H-156.472C-155.987 146.655 -155.594 146.262 -155.594 145.777C-155.594 145.291 -155.987 144.898 -156.472 144.898H-162.182V143.937H-158.434C-157.949 143.937 -157.556 143.544 -157.556 143.058C-157.556 142.573 -157.949 142.179 -158.434 142.179H-162.182V141.219H-156.654C-156.169 141.219 -155.775 140.825 -155.775 140.34C-155.775 139.854 -156.169 139.461 -156.654 139.461H-162.182V137.985H-158.083C-157.598 137.985 -157.204 137.591 -157.204 137.106C-157.204 136.621 -157.598 136.227 -158.083 136.227H-162.182V134.575H-159.412C-158.927 134.575 -158.534 134.181 -158.534 133.696C-158.534 133.211 -158.927 132.817 -159.412 132.817H-162.182V131.681H-158.434C-157.949 131.681 -157.556 131.287 -157.556 130.802C-157.556 130.317 -157.949 129.923 -158.434 129.923H-162.182V128.441H-158.879C-158.394 128.441 -158.001 128.048 -158.001 127.562C-158.001 127.077 -158.394 126.683 -158.879 126.683H-162.182V125.031H-161.725C-161.24 125.031 -160.847 124.638 -160.847 124.153C-160.847 123.667 -161.24 123.274 -161.725 123.274H-162.182V122.313H-160.923C-160.438 122.313 -160.044 121.919 -160.044 121.434C-160.044 120.949 -160.438 120.555 -160.923 120.555H-162.182V119.044C-161.767 118.924 -161.501 118.519 -161.555 118.09C-161.609 117.661 -161.967 117.335 -162.399 117.321H-163.74C-164.172 117.335 -164.53 117.661 -164.583 118.09C-164.637 118.519 -164.372 118.924 -163.956 119.044V120.561H-165.479C-165.964 120.561 -166.357 120.955 -166.357 121.44C-166.357 121.925 -165.964 122.319 -165.479 122.319H-163.956V123.28H-165.215C-165.701 123.28 -166.094 123.673 -166.094 124.158C-166.094 124.644 -165.701 125.037 -165.215 125.037H-163.956V126.695H-167.253C-167.739 126.695 -168.132 127.089 -168.132 127.574C-168.132 128.059 -167.739 128.453 -167.253 128.453H-163.951V129.935H-168.501C-168.986 129.935 -169.379 130.328 -169.379 130.814C-169.379 131.299 -168.986 131.693 -168.501 131.693H-163.951V132.829H-167.253C-167.739 132.816 -168.142 133.199 -168.155 133.684C-168.168 134.17 -167.785 134.574 -167.3 134.587H-163.951V136.245H-168.682C-169.167 136.245 -169.561 136.638 -169.561 137.123C-169.561 137.609 -169.167 138.002 -168.682 138.002H-163.951V139.473H-170.392C-170.608 139.472 -170.817 139.551 -170.978 139.695C-171.945 138.67 -173.212 137.976 -174.597 137.715C-175.499 135.225 -177.595 133.479 -180.037 133.479C-181.387 133.503 -182.678 134.037 -183.651 134.973C-184.88 133.491 -187.235 133.063 -189.325 134.065C-190.483 134.606 -191.401 135.552 -191.908 136.725C-195.691 136.965 -198.672 139.543 -198.672 142.695C-198.673 143.295 -198.566 143.89 -198.356 144.453C-198.715 144.506 -199.064 144.612 -199.392 144.769C-201.277 145.857 -202.005 148.214 -201.061 150.176C-200.118 152.137 -197.822 153.039 -195.796 152.244L-195.627 152.151C-195.635 152.826 -195.487 153.494 -195.193 154.102C-194.459 155.705 -192.789 156.665 -191.035 156.492L-189.208 160.007L-184.576 161.935V168.854L-184.763 168.947C-186.499 165.922 -189.71 164.047 -193.196 164.02C-198.385 164.02 -202.631 168.168 -203.046 173.441C-203.343 173.403 -203.643 173.383 -203.942 173.382C-207.761 173.382 -210.97 176.405 -212.071 180.577L-218.963 183.301C-222.25 184.599 -224.421 187.763 -224.451 191.298C-224.957 193.38 -224.88 195.561 -224.228 197.602H212.226C212.935 195.76 213.018 193.736 212.46 191.843C212.333 190.039 211.56 188.341 210.282 187.062L193.885 170.658L173.066 157.57L157.84 151.014C157.363 150.809 156.867 150.654 156.358 150.551L153.823 150.036L151.785 149.579ZM-259.634 192.932H-249.784V193.993H-256.812C-257.193 193.981 -257.512 194.282 -257.523 194.664C-257.535 195.045 -257.234 195.364 -256.853 195.375H-249.79V197.602H-248.402V195.375H-242.411C-242.03 195.387 -241.711 195.086 -241.7 194.705C-241.689 194.323 -241.989 194.004 -242.37 193.993H-248.402V192.932H-240.526C-240.142 192.932 -239.832 192.622 -239.832 192.238C-239.832 191.855 -240.142 191.544 -240.526 191.544H-248.396V189.98H-241.808C-241.425 189.98 -241.114 189.669 -241.114 189.285C-241.114 188.902 -241.425 188.591 -241.808 188.591H-248.396V186.834H-242.745C-242.362 186.834 -242.051 186.523 -242.051 186.139C-242.051 185.756 -242.362 185.445 -242.745 185.445H-248.396V184.215H-244.637C-244.255 184.226 -243.937 183.926 -243.925 183.544C-243.914 183.162 -244.214 182.843 -244.596 182.832H-248.396V181.602H-242.921C-242.538 181.602 -242.227 181.291 -242.227 180.908C-242.227 180.524 -242.538 180.213 -242.921 180.213H-248.402V178.456H-244.303C-243.92 178.456 -243.609 178.145 -243.609 177.762C-243.609 177.378 -243.92 177.067 -244.303 177.067H-248.402V175.163H-245.58C-245.196 175.163 -244.886 174.852 -244.886 174.469C-244.886 174.086 -245.196 173.775 -245.58 173.775H-248.402V172.38H-244.643C-244.259 172.38 -243.949 172.07 -243.949 171.686C-243.949 171.303 -244.259 170.992 -244.643 170.992H-248.408V169.234H-245.076C-244.693 169.234 -244.382 168.924 -244.382 168.54C-244.382 168.157 -244.693 167.846 -245.076 167.846H-248.414V165.948H-247.828C-247.445 165.948 -247.134 165.637 -247.134 165.253C-247.134 164.87 -247.445 164.559 -247.828 164.559H-248.414V163.434H-247.05C-246.666 163.434 -246.356 163.124 -246.356 162.74C-246.356 162.357 -246.666 162.046 -247.05 162.046H-248.414V160.288C-248.057 160.244 -247.794 159.933 -247.809 159.573C-247.825 159.213 -248.113 158.926 -248.473 158.912H-249.743C-250.123 158.895 -250.445 159.19 -250.461 159.571C-250.477 159.951 -250.182 160.272 -249.802 160.288V162.046H-251.407C-251.79 162.046 -252.1 162.357 -252.1 162.74C-252.1 163.124 -251.79 163.434 -251.407 163.434H-249.784V164.665H-251.149C-251.532 164.665 -251.843 164.975 -251.843 165.359C-251.843 165.742 -251.532 166.053 -251.149 166.053H-249.784V167.951H-253.117C-253.5 167.951 -253.81 168.262 -253.81 168.646C-253.81 169.029 -253.5 169.34 -253.117 169.34H-249.778V171.097H-254.311C-254.694 171.097 -255.005 171.408 -255.005 171.792C-255.005 172.175 -254.694 172.486 -254.311 172.486H-249.773V173.88H-253.105C-253.488 173.88 -253.799 174.191 -253.799 174.574C-253.799 174.958 -253.488 175.269 -253.105 175.269H-249.767V177.173H-254.452C-254.835 177.173 -255.146 177.484 -255.146 177.867C-255.146 178.25 -254.835 178.561 -254.452 178.561H-249.767V180.319H-256.121C-256.504 180.319 -256.815 180.63 -256.815 181.013C-256.815 181.396 -256.504 181.707 -256.121 181.707H-249.784V182.938H-254.405C-254.652 182.93 -254.884 183.055 -255.014 183.265C-255.143 183.476 -255.151 183.739 -255.034 183.957C-254.917 184.174 -254.693 184.313 -254.446 184.32H-249.761V185.551H-257.233C-257.617 185.551 -257.927 185.861 -257.927 186.245C-257.927 186.628 -257.617 186.939 -257.233 186.939H-249.784V188.697H-256.976C-257.359 188.697 -257.67 189.007 -257.67 189.391C-257.67 189.774 -257.359 190.085 -256.976 190.085H-249.784V191.556H-259.634C-260.018 191.556 -260.328 191.866 -260.328 192.25C-260.328 192.633 -260.018 192.944 -259.634 192.944V192.932ZM336.699 178.813L339.955 170.342L364.357 157.529V150.627H357.623C357.256 150.627 356.958 150.33 356.958 149.963C356.958 149.595 357.256 149.298 357.623 149.298H364.357V148.284H354.906C354.539 148.284 354.241 147.986 354.241 147.619C354.241 147.252 354.539 146.954 354.906 146.954H364.357V145.454H357.459C357.092 145.454 356.794 145.157 356.794 144.789C356.794 144.422 357.092 144.124 357.459 144.124H364.317V142.461H357.172C356.805 142.461 356.507 142.163 356.507 141.796C356.507 141.428 356.805 141.131 357.172 141.131H364.317V139.959H359.883C359.516 139.959 359.219 139.661 359.219 139.294C359.219 138.927 359.516 138.629 359.883 138.629H364.317V137.457H358.238C357.871 137.457 357.573 137.16 357.573 136.792C357.573 136.425 357.871 136.127 358.238 136.127H364.317V134.464H359.801C359.434 134.464 359.137 134.166 359.137 133.799C359.137 133.431 359.434 133.134 359.801 133.134H364.322V131.306H361.125C360.758 131.306 360.46 131.008 360.46 130.641C360.46 130.274 360.758 129.976 361.125 129.976H364.322V128.634H359.971C359.604 128.634 359.307 128.337 359.307 127.969C359.307 127.602 359.604 127.304 359.971 127.304H364.322V125.641H361.125C360.758 125.641 360.46 125.343 360.46 124.976C360.46 124.608 360.758 124.311 361.125 124.311H364.322V122.483H363.016C362.673 122.451 362.411 122.163 362.411 121.818C362.411 121.473 362.673 121.185 363.016 121.153H364.322V119.981H362.765C362.398 119.981 362.1 119.684 362.1 119.316C362.1 118.949 362.398 118.651 362.765 118.651H364.322V116.976C363.981 116.932 363.73 116.634 363.745 116.29C363.761 115.946 364.037 115.671 364.381 115.658H365.599C365.943 115.671 366.219 115.946 366.235 116.29C366.25 116.634 365.999 116.932 365.658 116.976V118.657H366.964C367.306 118.689 367.569 118.977 367.569 119.322C367.569 119.667 367.306 119.955 366.964 119.987H365.658V121.159H366.243C366.61 121.159 366.908 121.456 366.908 121.824C366.908 122.191 366.61 122.489 366.243 122.489H365.658V124.311H368.855C369.222 124.311 369.52 124.608 369.52 124.976C369.52 125.343 369.222 125.641 368.855 125.641H365.658V127.304H369.271C369.638 127.304 369.935 127.602 369.935 127.969C369.935 128.337 369.638 128.634 369.271 128.634H365.658V129.976H368.363C368.73 129.976 369.028 130.274 369.028 130.641C369.028 131.008 368.73 131.306 368.363 131.306H365.658V133.128H369.599C369.966 133.128 370.263 133.426 370.263 133.793C370.263 134.16 369.966 134.458 369.599 134.458H365.658V136.127H370.928C371.295 136.127 371.593 136.425 371.593 136.792C371.593 137.16 371.295 137.457 370.928 137.457H365.658V138.629H369.271C369.638 138.629 369.935 138.927 369.935 139.294C369.935 139.661 369.638 139.959 369.271 139.959H365.658V141.131H371.08C371.447 141.131 371.745 141.428 371.745 141.796C371.745 142.163 371.447 142.461 371.08 142.461H365.658V144.124H371.982C372.349 144.124 372.647 144.422 372.647 144.789C372.647 145.157 372.349 145.454 371.982 145.454H365.658V146.954H373.218C373.585 146.954 373.883 147.252 373.883 147.619C373.883 147.986 373.585 148.284 373.218 148.284H365.658V149.298H371.408C371.775 149.298 372.073 149.595 372.073 149.963C372.073 150.33 371.775 150.627 371.408 150.627H365.658V156.486L374.963 148.477C375.865 147.698 376.991 147.227 378.178 147.13L383.261 146.72V142.343H376.199C375.932 142.233 375.762 141.968 375.773 141.68C375.783 141.391 375.972 141.14 376.245 141.049H383.273V139.988H373.423C373.04 139.988 372.729 139.677 372.729 139.294C372.729 138.911 373.04 138.6 373.423 138.6H383.273V137.036H376.082C375.698 137.036 375.388 136.725 375.388 136.341C375.388 135.958 375.698 135.647 376.082 135.647H383.296V133.889H375.847C375.464 133.889 375.153 133.579 375.153 133.195C375.153 132.812 375.464 132.501 375.847 132.501H383.296V131.271H378.611C378.365 131.263 378.14 131.125 378.023 130.907C377.906 130.69 377.914 130.426 378.044 130.216C378.173 130.006 378.406 129.881 378.652 129.888H383.273V128.658H376.937C376.553 128.658 376.243 128.347 376.243 127.964C376.243 127.58 376.553 127.269 376.937 127.269H383.273V125.512H378.588C378.205 125.512 377.894 125.201 377.894 124.817C377.894 124.434 378.205 124.123 378.588 124.123H383.273V122.219H379.935C379.552 122.219 379.241 121.908 379.241 121.525C379.241 121.142 379.552 120.831 379.935 120.831H383.267V119.436H378.693C378.446 119.429 378.222 119.291 378.105 119.073C377.988 118.855 377.996 118.592 378.126 118.382C378.255 118.171 378.487 118.046 378.734 118.054H383.267V116.296H379.894C379.647 116.289 379.423 116.15 379.306 115.933C379.189 115.715 379.196 115.452 379.326 115.241C379.456 115.031 379.688 114.906 379.935 114.914H383.267V113.009H381.862C381.48 112.998 381.18 112.679 381.191 112.298C381.202 111.916 381.521 111.616 381.903 111.627H383.267V110.397H381.645C381.262 110.397 380.951 110.086 380.951 109.702C380.951 109.319 381.262 109.008 381.645 109.008H383.267V107.251C382.887 107.234 382.592 106.913 382.608 106.533C382.624 106.153 382.946 105.858 383.326 105.874H384.596C384.976 105.858 385.298 106.153 385.314 106.533C385.33 106.913 385.035 107.234 384.655 107.251V109.008H386.019C386.403 109.008 386.713 109.319 386.713 109.702C386.713 110.086 386.403 110.397 386.019 110.397H384.655V111.627H385.287C385.534 111.634 385.759 111.773 385.876 111.99C385.993 112.208 385.985 112.471 385.855 112.682C385.725 112.892 385.493 113.017 385.246 113.009H384.661V114.884H388.034C388.416 114.896 388.716 115.214 388.704 115.596C388.693 115.978 388.375 116.278 387.993 116.267H384.661V118.024H388.426C388.81 118.024 389.12 118.335 389.12 118.719C389.12 119.102 388.81 119.413 388.426 119.413H384.661V120.807H387.483C387.867 120.807 388.177 121.118 388.177 121.502C388.177 121.885 387.867 122.196 387.483 122.196H384.667V124.065H388.766C389.149 124.065 389.46 124.375 389.46 124.759C389.46 125.142 389.149 125.453 388.766 125.453H384.667V127.211H390.142C390.525 127.211 390.836 127.522 390.836 127.905C390.836 128.288 390.525 128.599 390.142 128.599H384.667V129.829H388.467C388.849 129.841 389.149 130.16 389.138 130.541C389.127 130.923 388.808 131.223 388.426 131.212H384.661V132.413H390.312C390.695 132.413 391.006 132.724 391.006 133.107C391.006 133.491 390.695 133.802 390.312 133.802H384.667V135.559H391.255C391.638 135.559 391.949 135.87 391.949 136.253C391.949 136.637 391.638 136.948 391.255 136.948H384.667V138.512H392.543C392.926 138.512 393.237 138.823 393.237 139.206C393.237 139.59 392.926 139.9 392.543 139.9H384.667V140.961H390.698C390.945 140.968 391.17 141.107 391.287 141.324C391.404 141.542 391.396 141.805 391.266 142.016C391.136 142.226 390.904 142.351 390.658 142.343H384.667V146.614L391.483 146.064C394.722 143.849 400.162 143.269 405.983 144.687V141.681C402.276 141.213 399.389 137.434 399.389 132.841C399.389 127.931 402.692 123.947 406.768 123.947C410.844 123.947 414.147 127.931 414.147 132.841C414.147 137.241 411.494 140.885 408.009 141.599V145.232L408.683 145.454C413.637 147.212 417.625 150.001 419.968 153.071C420.001 153.067 420.038 153.062 420.08 153.057C420.133 153.05 420.193 153.043 420.259 153.034C420.461 153.009 420.725 152.974 421.049 152.931L421.054 152.931C431.048 151.619 497.504 142.894 524.6 160.716C525.36 162.21 526.46 164.066 527.631 166.042C530.539 170.948 533.884 176.592 533.542 179.253L538.198 190.173C538.582 191.074 538.724 192.059 538.608 193.032C538.617 193.361 538.646 193.85 538.671 194.296L538.672 194.3L538.69 194.614C538.704 194.867 538.719 195.114 538.734 195.354C538.785 196.177 538.83 196.921 538.83 197.602H535.065C536.151 197.19 537.078 196.443 537.712 195.469C537.068 196.439 536.139 197.184 535.053 197.602H314.44C314.186 196.617 314.079 195.6 314.123 194.584C314.197 193.139 314.826 191.779 315.88 190.788L336.699 178.813ZM47.5683 134.171H55.1813C55.6664 134.171 56.0597 133.777 56.0597 133.292C56.0597 132.807 55.6664 132.413 55.1813 132.413H47.5683V131.077H57.5237C57.8748 131.075 58.1906 130.863 58.3269 130.54C58.4632 130.216 58.3938 129.842 58.1504 129.589H68.6915V130.931H59.8311C59.3459 130.931 58.9526 131.324 58.9526 131.81C58.9526 132.295 59.3459 132.688 59.8311 132.688H68.7207V135.747C65.0255 135.594 61.7753 136.333 59.5324 137.803L47.5683 134.874V134.171ZM45.8114 134.458V134.171H44.6402L45.8114 134.458ZM1.56808 106.606C3.09708 106.417 4.54407 105.808 5.74939 104.848C5.9335 104.995 6.12936 105.126 6.33499 105.241L5.28674 108.123L1.56808 108.949V106.606ZM-9.78702 98.4509L-9.61719 98.3572V98.3689C-9.48242 98.3016 -9.34354 98.2429 -9.20142 98.1931C-9.38879 98.1521 -9.59375 98.1053 -9.78702 98.0525V98.4509ZM-4.45203 108.774L-5.9805 105.844C-5.45139 105.585 -4.99319 105.201 -4.64529 104.725C-3.50497 105.678 -2.13324 106.313 -0.668945 106.565V110.361L-4.45203 108.774ZM-28.6731 119.999H-35.765V124.322C-33.6565 122.498 -31.26 121.037 -28.6731 119.999ZM-37.6155 118.153H-45.8727C-45.6526 117.645 -45.4781 117.117 -45.3515 116.577H-37.6155V118.153ZM-45.0938 114.732H-37.6565V112.447H-45.2695C-45.1541 113.053 -45.0953 113.669 -45.0938 114.287V114.732ZM-46.9854 108.082H-37.6155V110.602H-45.8141C-46.2197 109.594 -46.8163 108.675 -47.571 107.895C-47.4128 108.016 -47.2195 108.082 -47.0205 108.082H-46.9854ZM-53.0406 122.612C-54.2776 123.806 -55.8062 124.654 -57.4738 125.072L-57.4445 125.078V131.816C-56.1288 131.718 -54.8131 131.681 -53.4974 131.704L-37.5745 126.086V119.993H-46.4173C-46.5663 119.993 -46.7131 119.957 -46.8448 119.887C-48.0528 121.611 -50.0114 122.654 -52.1154 122.694C-52.4255 122.691 -52.7349 122.664 -53.0406 122.612ZM-63.5993 127.492L-65.5611 124.293C-65.2126 124.269 -64.8662 124.22 -64.5246 124.147C-63.1868 124.89 -61.6912 125.304 -60.1617 125.354V128.699L-63.5993 127.492ZM-168.753 148.138H-163.939V146.655H-168.87C-168.745 147.139 -168.705 147.64 -168.753 148.138ZM-169.982 141.224H-163.939V142.185H-168.577C-169.062 142.185 -169.455 142.579 -169.455 143.064C-169.455 143.549 -169.062 143.943 -168.577 143.943H-163.939V144.904H-169.795C-169.9 144.78 -170.011 144.663 -170.129 144.552C-169.632 143.509 -169.586 142.308 -170 141.23L-169.982 141.224ZM-163.939 149.895H-169.338C-169.688 150.451 -170.182 150.903 -170.767 151.202H-163.939V149.895ZM-182.31 156.925L-182.286 156.923V159.245L-178.591 158.443L-177.543 155.56C-177.749 155.446 -177.944 155.315 -178.128 155.168C-179.327 156.123 -180.766 156.73 -182.286 156.923V156.902L-182.31 156.925ZM-177.73 159.445L-182.31 160.441L-182.315 160.458V167.735L-179.206 166.205C-178.023 165.624 -176.723 165.32 -175.405 165.315L-166.434 165.28C-165.845 164.014 -164.995 162.888 -163.939 161.976V155.484H-171.072C-171.557 155.484 -171.95 155.091 -171.95 154.605C-171.95 154.12 -171.557 153.727 -171.072 153.727H-163.933V152.942H-171.932C-172.124 154.155 -172.893 155.199 -173.994 155.742C-174.766 156.109 -175.642 156.196 -176.471 155.988L-177.73 159.445ZM-193.495 148.659L-193.665 148.753V148.354C-193.466 148.407 -193.267 148.454 -193.079 148.495C-193.221 148.543 -193.36 148.6 -193.495 148.665V148.659ZM-189.864 156.158L-188.336 159.087L-184.553 160.675V156.879C-186.017 156.627 -187.389 155.992 -188.529 155.039C-188.877 155.515 -189.335 155.899 -189.864 156.158ZM-310.407 188.843V197.602H-308.686V188.773C-305.758 188.187 -303.485 185.082 -303.485 181.35C-303.485 177.184 -306.285 173.816 -309.74 173.816C-313.195 173.816 -316 177.19 -316 181.35C-316 185.24 -313.552 188.445 -310.407 188.843ZM-272.178 191.848H-282.796V191.878C-283.182 191.843 -283.479 191.519 -283.479 191.131C-283.479 190.742 -283.182 190.418 -282.796 190.384H-272.178V188.685H-279.932C-280.319 188.651 -280.615 188.326 -280.615 187.938C-280.615 187.549 -280.319 187.225 -279.932 187.191H-272.178V185.322H-280.207C-280.594 185.288 -280.891 184.964 -280.891 184.575C-280.891 184.187 -280.594 183.862 -280.207 183.828H-272.178V182.504H-277.162C-277.549 182.47 -277.845 182.146 -277.845 181.757C-277.845 181.369 -277.549 181.044 -277.162 181.01H-272.178V179.668H-279.007C-279.393 179.634 -279.69 179.31 -279.69 178.922C-279.69 178.533 -279.393 178.209 -279.007 178.175H-272.178V176.306H-277.25C-277.637 176.271 -277.933 175.947 -277.933 175.559C-277.933 175.17 -277.637 174.846 -277.25 174.812H-272.178V172.761H-275.774C-276.161 172.727 -276.457 172.403 -276.457 172.014C-276.457 171.626 -276.161 171.302 -275.774 171.267H-272.178V169.762H-277.068C-277.455 169.727 -277.752 169.403 -277.752 169.015C-277.752 168.626 -277.455 168.302 -277.068 168.268H-272.178V166.399H-275.774C-276.161 166.364 -276.457 166.04 -276.457 165.652C-276.457 165.263 -276.161 164.939 -275.774 164.905H-272.178V162.854H-273.648C-274.035 162.82 -274.332 162.496 -274.332 162.107C-274.332 161.719 -274.035 161.395 -273.648 161.36H-272.178V160.036H-273.935C-274.322 160.002 -274.619 159.678 -274.619 159.289C-274.619 158.901 -274.322 158.577 -273.935 158.542H-272.178V156.662C-272.564 156.615 -272.849 156.279 -272.832 155.891C-272.815 155.503 -272.502 155.193 -272.114 155.18H-270.744C-270.355 155.193 -270.043 155.503 -270.026 155.891C-270.009 156.279 -270.294 156.615 -270.679 156.662V158.542H-269.209C-268.822 158.577 -268.526 158.901 -268.526 159.289C-268.526 159.678 -268.822 160.002 -269.209 160.036H-270.679V161.355H-270.041C-269.654 161.389 -269.357 161.713 -269.357 162.102C-269.357 162.49 -269.654 162.814 -270.041 162.848H-270.679V164.905H-267.083C-266.697 164.939 -266.4 165.263 -266.4 165.652C-266.4 166.04 -266.697 166.364 -267.083 166.399H-270.679V168.268H-266.621C-266.234 168.302 -265.937 168.626 -265.937 169.015C-265.937 169.403 -266.234 169.727 -266.621 169.762H-270.679V171.285H-267.64C-267.253 171.319 -266.956 171.643 -266.956 172.032C-266.956 172.42 -267.253 172.744 -267.64 172.779H-270.679V174.829H-266.252C-265.865 174.864 -265.568 175.188 -265.568 175.576C-265.568 175.965 -265.865 176.289 -266.252 176.323H-270.679V178.145H-264.776C-264.389 178.18 -264.093 178.504 -264.093 178.892C-264.093 179.281 -264.389 179.605 -264.776 179.639H-270.679V180.963H-266.621C-266.234 180.998 -265.937 181.322 -265.937 181.71C-265.937 182.099 -266.234 182.423 -266.621 182.457H-270.679V183.781H-264.589C-264.202 183.816 -263.905 184.14 -263.905 184.528C-263.905 184.917 -264.202 185.241 -264.589 185.275H-270.679V187.144H-263.576C-263.189 187.178 -262.892 187.503 -262.892 187.891C-262.892 188.279 -263.189 188.604 -263.576 188.638H-270.679V190.325H-262.194C-261.807 190.36 -261.51 190.684 -261.51 191.072C-261.51 191.461 -261.807 191.785 -262.194 191.819H-270.685V192.991H-264.243C-263.856 193.025 -263.56 193.349 -263.56 193.738C-263.56 194.126 -263.856 194.451 -264.243 194.485H-270.685V197.602H-272.178V194.485H-279.744C-280.131 194.451 -280.428 194.126 -280.428 193.738C-280.428 193.349 -280.131 193.025 -279.744 192.991H-272.178V191.848Z"
          fill="#C3DDF4"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M264.482 78.4725C264.482 71.8374 259.495 66.4577 253.345 66.4577C247.193 66.4577 242.206 71.8374 242.206 78.4725C242.206 85.1077 247.193 90.4873 253.345 90.4873C259.495 90.4873 264.482 85.1077 264.482 78.4725Z"
          fill="white"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M270.177 83.2354C270.177 79.8426 267.627 77.0922 264.482 77.0922C261.337 77.0922 258.787 79.8426 258.787 83.2354C258.787 86.6282 261.337 89.3785 264.482 89.3785C267.627 89.3785 270.177 86.6282 270.177 83.2354Z"
          fill="white"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M238.463 83.2354C238.463 79.8426 235.913 77.0922 232.768 77.0922C229.622 77.0922 227.072 79.8426 227.072 83.2354C227.072 86.6282 229.622 89.3785 232.768 89.3785C235.913 89.3785 238.463 86.6282 238.463 83.2354Z"
          fill="white"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M251.25 81.0267C251.25 75.9491 247.435 71.8333 242.728 71.8333C238.021 71.8333 234.206 75.9491 234.206 81.0267C234.206 86.1042 238.021 90.22 242.728 90.22C247.435 90.22 251.25 86.1042 251.25 81.0267Z"
          fill="white"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M225.15 91.3174H276.05C277.773 91.3174 279.17 89.8109 279.17 87.9518C279.17 86.0938 277.773 84.5868 276.05 84.5868H225.15C223.427 84.5868 222.031 86.0938 222.031 87.9518C222.031 89.8109 223.427 91.3174 225.15 91.3174Z"
          fill="white"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M78.1345 59.9549C78.1345 55.2588 74.3224 51.4517 69.6201 51.4517C64.9177 51.4517 61.1056 55.2588 61.1056 59.9549C61.1056 64.6509 64.9177 68.458 69.6201 68.458C74.3224 68.458 78.1345 64.6509 78.1345 59.9549Z"
          fill="white"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M85.0142 62.1771C85.0142 59.1419 82.5504 56.6814 79.5112 56.6814C76.4714 56.6814 74.0077 59.1419 74.0077 62.1771C74.0077 65.2128 76.4714 67.6733 79.5112 67.6733C82.5504 67.6733 85.0142 65.2128 85.0142 62.1771Z"
          fill="white"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M91.5714 63.6613C91.5714 61.2791 89.6376 59.3473 87.2517 59.3473C84.8663 59.3473 82.9319 61.2791 82.9319 63.6613C82.9319 66.0441 84.8663 67.9759 87.2517 67.9759C89.6376 67.9759 91.5714 66.0441 91.5714 63.6613Z"
          fill="white"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M68.019 61.7623C68.019 58.1684 65.1021 55.2554 61.5041 55.2554C57.906 55.2554 54.9891 58.1684 54.9891 61.7623C54.9891 65.3555 57.906 68.2686 61.5041 68.2686C65.1021 68.2686 68.019 65.3555 68.019 61.7623Z"
          fill="white"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M61.1127 68.6058H93.7848C94.8585 68.6058 95.7292 67.7362 95.7292 66.6639C95.7292 65.5911 94.8585 64.7221 93.7848 64.7221H61.1127C60.039 64.7221 59.1683 65.5911 59.1683 66.6639C59.1683 67.7362 60.039 68.6058 61.1127 68.6058Z"
          fill="white"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M98.9949 68.5103H100.7C101.618 68.5103 102.363 67.7662 102.363 66.8494C102.363 65.9316 101.618 65.1886 100.7 65.1886H98.9949C98.0764 65.1886 97.3318 65.9316 97.3318 66.8494C97.3318 67.7662 98.0764 68.5103 98.9949 68.5103Z"
          fill="white"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M49.0582 68.9436H49.9801C50.8992 68.9436 51.6437 68.1995 51.6437 67.2827C51.6437 66.3648 50.8992 65.6219 49.9801 65.6219H49.0582C48.1397 65.6219 47.3951 66.3648 47.3951 67.2827C47.3951 68.1995 48.1397 68.9436 49.0582 68.9436Z"
          fill="white"
        />
      </g>
      <path
        d="M12 201H820"
        stroke="#001E60"
        stroke-width="4"
        stroke-linecap="round"
      />
      <path
        d="M-15 201H2"
        stroke="#001E60"
        stroke-width="4"
        stroke-linecap="round"
      />
      {/* <mask
        id="mask1_10322_1855"
        style="mask-type:luminance"
        maskUnits="userSpaceOnUse"
        x="162"
        y="112"
        width="194"
        height="88"
      >
        <path
          d="M162.2 112H355.2L353 200H283.972L252.098 183L240.121 165L207.471 162L170.557 157.5L162.2 112Z"
          fill="white"
        />
      </mask> */}
      <g mask="url(#mask1_10322_1855)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M294.46 181.018C294.46 171.23 303.01 160.998 315.857 161.435C325.617 161.766 334.468 171.23 334.468 181.018C334.468 181.078 334.46 181.136 334.459 181.196H335.519L335.543 181.171H339.966C341.743 181.166 343.182 179.723 343.187 177.942V166.468C343.182 165.135 342.362 163.942 341.121 163.463C341.27 149.441 326.125 148.351 326.125 148.351L293.553 143.848L270.993 124.463C231.83 120.43 186.313 123.108 186.313 123.108C180.091 122.834 176.263 131.663 176.263 131.663L170.134 146.876L170.599 162.655C165.313 165.039 168.484 174.31 168.484 174.31C169.278 179.343 173.771 179.607 173.771 179.607L183.42 180.337C183.781 170.868 191.972 162.263 201.503 161.928C214.812 161.463 222.467 171.23 222.467 181.018H294.46H294.46Z"
          fill="white"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M314.714 195.57C307.651 195.57 301.926 189.832 301.926 182.754C301.926 179.355 303.273 176.096 305.671 173.692C308.07 171.289 311.322 169.939 314.714 169.939C321.776 169.939 327.501 175.677 327.501 182.754C327.501 189.832 321.776 195.57 314.714 195.57ZM202.953 195.725C195.89 195.725 190.165 189.988 190.165 182.91C190.165 179.511 191.513 176.251 193.911 173.848C196.309 171.444 199.561 170.094 202.953 170.094C210.015 170.094 215.74 175.832 215.74 182.91C215.74 189.988 210.015 195.725 202.953 195.725Z"
          fill="white"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M174.486 155.186H178.338C180.376 155.18 182.026 153.526 182.032 151.484V151.387C182.026 149.345 180.376 147.692 178.338 147.685H174.486V155.186Z"
          fill="#FF9E16"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M202.379 150.044C202.117 149.797 201.968 149.453 201.967 149.092C201.969 148.361 202.56 147.768 203.289 147.766H209.904C210.634 147.768 211.225 148.36 211.227 149.092C211.226 149.453 211.077 149.797 210.815 150.044C210.803 150.056 210.789 150.064 210.775 150.072C210.763 150.079 210.751 150.086 210.741 150.095C210.642 150.185 210.529 150.259 210.408 150.315C210.249 150.383 210.078 150.418 209.904 150.418H203.289C203.117 150.418 202.945 150.383 202.786 150.315C202.665 150.259 202.552 150.185 202.453 150.095C202.442 150.086 202.43 150.079 202.418 150.072C202.404 150.064 202.39 150.055 202.379 150.044ZM247.062 149.679V149.677V149.676C247.062 149.667 247.059 149.659 247.057 149.65C247.054 149.641 247.051 149.631 247.051 149.621C247.053 148.889 247.644 148.297 248.374 148.295H254.988C255.529 148.292 256.016 148.621 256.217 149.123C256.417 149.626 256.292 150.201 255.899 150.573C255.888 150.584 255.875 150.591 255.861 150.599C255.85 150.605 255.838 150.612 255.828 150.621C255.728 150.712 255.615 150.787 255.492 150.844C255.332 150.912 255.161 150.946 254.988 150.946H248.374C248.201 150.946 248.03 150.912 247.87 150.844C247.749 150.788 247.637 150.713 247.537 150.624C247.527 150.614 247.515 150.607 247.502 150.6C247.488 150.592 247.474 150.584 247.463 150.572C247.22 150.338 247.076 150.017 247.062 149.679Z"
          fill="#001E60"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M336.734 175.219V175.22C336.738 176.579 337.837 177.68 339.193 177.684H340.301V172.756H339.193C337.837 172.759 336.738 173.861 336.734 175.22"
          fill="#FF9E16"
        />
        <path
          d="M342.691 165.964C343.077 165.964 343.389 165.651 343.389 165.266C343.389 164.88 343.077 164.568 342.691 164.568V165.964ZM337.895 164.568C337.51 164.568 337.197 164.88 337.197 165.266C337.197 165.651 337.51 165.964 337.895 165.964V164.568ZM178.393 164.473C178.779 164.473 179.092 164.161 179.092 163.775C179.092 163.39 178.779 163.077 178.393 163.077V164.473ZM170.811 163.077C170.426 163.077 170.113 163.39 170.113 163.775C170.113 164.161 170.426 164.473 170.811 164.473V163.077ZM342.691 164.568H337.895V165.964H342.691V164.568ZM178.393 163.077H170.811V164.473H178.393V163.077Z"
          fill="#001E60"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M190.165 182.91C190.165 189.988 195.89 195.725 202.953 195.725C210.015 195.725 215.74 189.988 215.74 182.91C215.74 175.832 210.015 170.094 202.953 170.094C199.561 170.094 196.309 171.444 193.911 173.848C191.513 176.251 190.165 179.511 190.165 182.91V182.91Z"
          stroke="#001E60"
          stroke-width="6.98113"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M333.755 159.989H334.805C335.309 159.991 335.777 159.731 336.044 159.303C336.31 158.874 336.337 158.339 336.115 157.886C334.978 155.615 333.412 153.433 328.973 152.894C328.332 152.824 327.721 153.185 327.472 153.781C327.222 154.377 327.393 155.067 327.892 155.477C329.361 156.686 331.136 158.172 332.795 159.627C333.06 159.861 333.401 159.989 333.754 159.989H333.755Z"
          fill="#C2DCF3"
        />
        <path
          d="M220.541 162.445C220.793 162.737 221.233 162.771 221.526 162.519C221.818 162.268 221.852 161.827 221.6 161.535L220.541 162.445ZM215.887 155.956L216.416 155.501C216.284 155.348 216.093 155.259 215.891 155.258L215.887 155.956ZM189.572 155.801L189.576 155.103C189.378 155.102 189.19 155.184 189.056 155.33L189.572 155.801ZM183.948 160.915C183.688 161.199 183.708 161.641 183.992 161.901C184.277 162.161 184.718 162.141 184.978 161.857L183.948 160.915ZM334.462 165.633C334.751 165.887 335.192 165.859 335.447 165.569C335.701 165.28 335.673 164.839 335.383 164.584L334.462 165.633ZM324.861 156.266L325.322 155.742C325.2 155.635 325.045 155.574 324.883 155.568L324.861 156.266ZM305.357 155.646L305.379 154.948C305.19 154.942 305.007 155.013 304.871 155.145L305.357 155.646ZM297.208 162.592C296.932 162.86 296.926 163.302 297.194 163.579C297.463 163.855 297.905 163.862 298.181 163.593L297.208 162.592ZM221.6 161.535L216.416 155.501L215.357 156.411L220.541 162.445L221.6 161.535ZM215.891 155.258L189.576 155.103L189.567 156.499L215.882 156.654L215.891 155.258ZM189.056 155.33L183.948 160.915L184.978 161.857L190.087 156.272L189.056 155.33ZM335.383 164.584L325.322 155.742L324.4 156.791L334.462 165.633L335.383 164.584ZM324.883 155.568L305.379 154.948L305.335 156.344L324.839 156.964L324.883 155.568ZM304.871 155.145L297.208 162.592L298.181 163.593L305.844 156.146L304.871 155.145Z"
          fill="#001E60"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M301.926 182.754C301.926 189.832 307.651 195.57 314.714 195.57C321.776 195.57 327.501 189.832 327.501 182.754C327.501 175.677 321.776 169.939 314.714 169.939C311.322 169.939 308.07 171.289 305.671 173.692C303.273 176.096 301.926 179.355 301.926 182.754Z"
          stroke="#001E60"
          stroke-width="6.98113"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M241.504 171.336C241.516 171.721 241.838 172.024 242.223 172.012C242.608 172 242.911 171.678 242.899 171.293L241.504 171.336ZM241.427 146.182L242.125 146.161C242.124 146.128 242.121 146.096 242.115 146.063L241.427 146.182ZM239.329 129.93C239.263 129.55 238.902 129.295 238.522 129.36C238.142 129.426 237.888 129.787 237.953 130.167L239.329 129.93ZM204.133 130.35C204.299 130.002 204.152 129.585 203.804 129.419C203.456 129.252 203.04 129.399 202.873 129.747L204.133 130.35ZM196.228 145.251L195.598 144.95C195.555 145.039 195.532 145.137 195.53 145.236L196.228 145.251ZM195.375 152.373C195.367 152.758 195.672 153.078 196.058 153.086C196.443 153.094 196.762 152.789 196.771 152.403L195.375 152.373ZM242.899 171.293L242.125 146.161L240.73 146.204L241.504 171.336L242.899 171.293ZM242.115 146.063L239.329 129.93L237.953 130.167L240.739 146.301L242.115 146.063ZM202.873 129.747L195.598 144.95L196.858 145.553L204.133 130.35L202.873 129.747ZM195.53 145.236L195.375 152.373L196.771 152.403L196.926 145.267L195.53 145.236Z"
          fill="#001E60"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M284.442 145.572L268.928 130.838C268.723 130.643 268.453 130.53 268.171 130.52L242.661 129.589C242.305 129.578 241.962 129.729 241.731 130.001C241.501 130.275 241.409 130.639 241.482 130.989L244.605 146.004C244.715 146.536 245.179 146.921 245.722 146.93L283.624 147.58H283.644C284.119 147.58 284.546 147.29 284.722 146.848C284.898 146.405 284.787 145.9 284.442 145.572H284.442Z"
          fill="#C2DCF3"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M252.806 138.642L244.414 145.084V145.085L243.993 143.063L251.677 137.164C251.939 136.952 252.296 136.899 252.609 137.026C252.921 137.154 253.14 137.44 253.181 137.776C253.222 138.111 253.078 138.443 252.806 138.642ZM246.999 146.797C246.916 146.863 246.814 146.899 246.709 146.899V146.899C246.512 146.899 246.336 146.774 246.271 146.588C246.205 146.402 246.264 146.194 246.418 146.07L253.516 140.382C253.645 140.275 253.822 140.246 253.978 140.307C254.135 140.367 254.246 140.507 254.271 140.673C254.295 140.839 254.229 141.005 254.097 141.108L246.999 146.797Z"
          fill="#E5F0FA"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M199.079 130.039C198.87 129.697 198.499 129.487 198.098 129.484L185.305 129.393H185.296C184.838 129.393 184.423 129.662 184.236 130.08L178.227 143.507C178.068 143.861 178.097 144.272 178.303 144.602C178.51 144.931 178.867 145.135 179.255 145.146L191.279 145.443L191.31 145.443C191.75 145.443 192.153 145.194 192.349 144.799L199.129 131.167C199.308 130.808 199.289 130.382 199.079 130.039V130.039Z"
          fill="#C2DCF3"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M188.359 129.415L185.849 131.427C185.648 131.587 185.616 131.88 185.776 132.081C185.936 132.282 186.229 132.314 186.429 132.154L189.833 129.426L188.359 129.415V129.415Z"
          fill="#E5F0FA"
        />
        <path
          d="M245.016 146.354L284.776 147.004"
          stroke="#001E60"
          stroke-width="1.39623"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M235.742 130.57C235.662 129.998 235.175 129.57 234.598 129.567L208.845 129.438H208.839C208.393 129.438 207.986 129.694 207.793 130.097L200.917 144.4C200.745 144.757 200.767 145.177 200.974 145.515C201.181 145.852 201.545 146.061 201.94 146.069L236.632 146.737H236.655C236.99 146.737 237.31 146.591 237.53 146.337C237.751 146.083 237.851 145.746 237.804 145.413L235.742 130.57H235.742Z"
          fill="#C2DCF3"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M209.55 133.689L215.046 129.469L218.081 129.485L210.679 135.167C210.416 135.37 210.064 135.415 209.758 135.288C209.452 135.16 209.236 134.879 209.193 134.549C209.15 134.219 209.286 133.891 209.55 133.689ZM215.726 133.134L220.266 129.495L221.743 129.503L216.307 133.86C216.106 134.017 215.818 133.983 215.659 133.784C215.5 133.585 215.53 133.296 215.726 133.134Z"
          fill="#E5F0FA"
        />
        <path
          d="M201.179 144.699C200.793 144.692 200.475 144.999 200.468 145.384C200.461 145.77 200.768 146.088 201.153 146.095L201.179 144.699ZM237.703 146.763C238.088 146.77 238.407 146.464 238.414 146.078C238.421 145.693 238.114 145.374 237.728 145.367L237.703 146.763ZM178.032 144.06C177.646 144.051 177.327 144.357 177.319 144.743C177.311 145.128 177.616 145.447 178.002 145.456L178.032 144.06ZM191.898 145.054V145.753C192.281 145.753 192.592 145.445 192.596 145.062C192.6 144.679 192.296 144.365 191.913 144.357L191.898 145.054ZM191.465 144.356C191.079 144.356 190.767 144.669 190.767 145.054C190.767 145.44 191.079 145.753 191.465 145.753V144.356ZM201.153 146.095L237.703 146.763L237.728 145.367L201.179 144.699L201.153 146.095ZM178.002 145.456L191.883 145.752L191.913 144.357L178.032 144.06L178.002 145.456ZM191.898 144.356H191.465V145.753H191.898V144.356Z"
          fill="#001E60"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M294.46 181.018C294.46 171.23 303.01 160.998 315.857 161.435C325.617 161.766 334.468 171.23 334.468 181.018C334.468 181.078 334.46 181.136 334.459 181.196H335.519L335.543 181.171H339.966C341.743 181.166 343.182 179.723 343.187 177.942V166.468C343.182 165.135 342.362 163.942 341.121 163.463C341.27 149.441 326.125 148.351 326.125 148.351L293.553 143.848L270.993 124.463C231.83 120.43 186.313 123.108 186.313 123.108C180.091 122.834 176.263 131.663 176.263 131.663L170.134 146.876L170.599 162.655C165.313 165.039 168.484 174.31 168.484 174.31C169.278 179.343 173.771 179.607 173.771 179.607L183.42 180.337C183.781 170.868 191.972 162.263 201.503 161.928C214.812 161.463 222.467 171.23 222.467 181.018H294.46H294.46Z"
          stroke="#001E60"
          stroke-width="4.18868"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M78.96 153.564L63.8221 154.231C63.8221 154.231 55.3781 155.207 56.6784 170.706C52.922 171.403 53.4319 177.983 53.4319 177.983V181.687C53.4319 185.973 58.5252 187.085 58.5252 187.085L81.4244 190.705C79.5591 183.436 82.4248 175.777 88.6082 171.505C94.7916 167.232 102.987 167.25 109.152 171.548C115.317 175.846 118.151 183.517 116.255 190.779H208.165C206.266 183.508 209.109 175.828 215.288 171.533C221.467 167.238 229.674 167.238 235.853 171.533C242.032 175.828 244.874 183.508 242.976 190.779H246.823L254.673 188.826C256.748 188.82 258.429 187.143 258.435 185.073L259.903 178.272C259.903 176.348 258.915 174.768 257.039 174.561C256.027 169.641 248.101 160.653 236.083 159.349L200.628 154.078C200.628 154.078 181.999 142.201 157.106 137.53C157.106 137.53 138.673 133.95 108.333 139.157C108.333 139.157 94.0597 142.574 78.9605 153.564H78.96Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M225.531 197.507C219.492 197.507 214.597 192.625 214.597 186.6C214.597 183.707 215.749 180.933 217.799 178.887C219.85 176.842 222.631 175.693 225.531 175.693C231.569 175.693 236.464 180.576 236.464 186.6C236.464 192.624 231.569 197.507 225.531 197.507ZM98.6225 197.661C92.6792 197.661 87.8615 192.854 87.8615 186.925C87.8615 180.996 92.6794 176.19 98.6225 176.19C104.566 176.19 109.384 180.996 109.384 186.925C109.384 192.854 104.566 197.661 98.6225 197.661Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M58.4303 168.571H63.6699C65.745 168.565 67.4259 166.888 67.4321 164.818V164.721C67.4259 162.65 65.745 160.974 63.6699 160.968H59.6728C59.2891 162.958 58.1704 165.445 58.4303 168.571Z"
        fill="#FF9E16"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M250.576 171.678C249.473 169.364 246.772 166.008 240.284 165.23C239.633 165.158 239.014 165.532 238.775 166.141C238.536 166.75 238.737 167.444 239.265 167.832C241.476 169.465 243.616 171.191 245.681 173.005C246.925 174.1 247.883 173.783 249.287 173.741C249.779 173.731 250.232 173.474 250.492 173.058C250.752 172.642 250.784 172.122 250.576 171.678Z"
        fill="#C2DCF3"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M117.898 161.656H110.176C109.323 161.656 108.632 160.966 108.632 160.115C108.632 159.264 109.323 158.574 110.176 158.574H117.898C118.752 158.574 119.443 159.264 119.443 160.115C119.443 160.966 118.752 161.656 117.898 161.656ZM154.629 162.866C153.777 162.864 153.087 162.176 153.085 161.326C153.087 160.476 153.777 159.787 154.629 159.785H162.352C163.205 159.785 163.897 160.474 163.897 161.326C163.897 162.177 163.205 162.866 162.352 162.866H154.629Z"
        fill="#001E60"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M145.016 154.874L106.787 154.789V154.788C106.418 154.788 106.087 154.565 105.947 154.225C105.807 153.884 105.887 153.494 106.149 153.235L115.77 143.741C115.887 143.625 116.034 143.542 116.194 143.502C124.197 141.519 134.44 141.346 142.989 141.313C143.433 141.312 143.812 141.631 143.886 142.067L145.915 153.812C145.961 154.076 145.887 154.347 145.713 154.552C145.54 154.756 145.285 154.874 145.016 154.874ZM152.961 155.129C152.961 155.129 150.757 144.156 150.407 142.405C150.179 141.269 150.832 141.35 151.324 141.423C176.048 145.086 192.633 155.602 192.633 155.602L152.961 155.129Z"
        fill="#C2DCF3"
      />
      <path
        d="M197.252 184.201H124.391"
        stroke="#001E60"
        stroke-width="1.62274"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M87.8615 186.925C87.8615 192.854 92.6792 197.661 98.6225 197.661C104.566 197.661 109.384 192.854 109.384 186.925C109.384 180.996 104.566 176.19 98.6225 176.19C92.6794 176.19 87.8615 180.997 87.8615 186.925V186.925Z"
        stroke="#001E60"
        stroke-width="5.37008"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M257.246 177.091H251.565"
        stroke="#001E60"
        stroke-width="1.62274"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M62.2512 172.762L57.7163 172.273"
        stroke="#001E60"
        stroke-width="1.21998"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M107.844 144.365L96.4248 154.942H86.1482C86.1482 154.942 97.7299 146.643 107.844 144.365Z"
        fill="#C2DCF3"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M123.322 146.135L128.864 141.713C129.429 141.675 129.996 141.64 130.562 141.609L123.934 146.897C123.723 147.061 123.419 147.026 123.251 146.817C123.084 146.609 123.116 146.305 123.322 146.135ZM116.813 146.718L122.557 142.328C123.808 142.164 125.061 142.026 126.317 141.914L118.003 148.268C117.726 148.49 117.35 148.545 117.021 148.412C116.691 148.279 116.461 147.978 116.417 147.626C116.374 147.274 116.526 146.926 116.813 146.718Z"
        fill="#E5F0FA"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M214.597 186.6C214.597 192.625 219.492 197.507 225.531 197.507C231.569 197.507 236.464 192.624 236.464 186.6C236.464 180.576 231.569 175.693 225.531 175.693C222.631 175.693 219.85 176.842 217.799 178.887C215.749 180.933 214.597 183.707 214.597 186.6H214.597Z"
        stroke="#001E60"
        stroke-width="5.37008"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M79.1342 185.535L59.5597 182.606"
        stroke="#001E60"
        stroke-width="1.21998"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M147.243 142.245L150.581 162.428V181.63"
        stroke="#001E60"
        stroke-width="1.46457"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M200.659 154.942V191.719"
        stroke="#001E60"
        stroke-width="0.976378"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M158.977 149.962L152.862 154.634V154.635L152.434 152.502L157.787 148.411C158.064 148.199 158.434 148.151 158.757 148.285C159.08 148.419 159.307 148.714 159.352 149.06C159.398 149.406 159.255 149.75 158.977 149.962ZM160.337 152.549L157.043 155.178L155.499 155.159L159.725 151.787C159.861 151.675 160.047 151.644 160.212 151.708C160.377 151.771 160.495 151.918 160.52 152.092C160.546 152.266 160.476 152.441 160.337 152.549Z"
        fill="#E5F0FA"
      />
      <path
        d="M110.826 145.437C111.105 145.144 111.095 144.681 110.802 144.401C110.51 144.122 110.047 144.132 109.767 144.424L110.826 145.437ZM95.1202 160.8L94.5909 160.294C94.4679 160.423 94.396 160.592 94.3885 160.769L95.1202 160.8ZM94.2251 164.675C94.2082 165.079 94.522 165.42 94.9261 165.437C95.3302 165.454 95.6715 165.14 95.6884 164.736L94.2251 164.675ZM153.949 154.722C153.545 154.717 153.213 155.041 153.208 155.445C153.203 155.85 153.527 156.182 153.931 156.187L153.949 154.722ZM192.624 156.66C193.028 156.665 193.36 156.341 193.365 155.937C193.37 155.532 193.046 155.201 192.642 155.196L192.624 156.66ZM106.049 154.377C105.645 154.376 105.316 154.704 105.315 155.108C105.314 155.512 105.642 155.841 106.046 155.842L106.049 154.377ZM146.097 155.934C146.502 155.935 146.83 155.608 146.831 155.204C146.832 154.799 146.505 154.471 146.101 154.47L146.097 155.934ZM95.4466 156C95.851 156 96.1789 155.672 96.1789 155.267C96.1789 154.863 95.851 154.535 95.4466 154.535V156ZM85.6593 154.535C85.2549 154.535 84.9271 154.863 84.9271 155.267C84.9271 155.672 85.2549 156 85.6593 156V154.535ZM109.767 144.424L94.5909 160.294L95.6494 161.306L110.826 145.437L109.767 144.424ZM94.3885 160.769L94.2251 164.675L95.6884 164.736L95.8518 160.831L94.3885 160.769ZM153.931 156.187L192.624 156.66L192.642 155.196L153.949 154.722L153.931 156.187ZM106.046 155.842L146.097 155.934L146.101 154.47L106.049 154.377L106.046 155.842ZM95.4466 154.535H85.6593V156H95.4466V154.535Z"
        fill="#001E60"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M78.96 153.564L63.8221 154.231C63.8221 154.231 55.3781 155.207 56.6784 170.706C52.922 171.403 53.4319 177.983 53.4319 177.983V181.687C53.4319 185.973 58.5252 187.085 58.5252 187.085L81.4244 190.705C79.5591 183.436 82.4248 175.777 88.6082 171.505C94.7916 167.232 102.987 167.25 109.152 171.548C115.317 175.846 118.151 183.517 116.255 190.779H208.165C206.266 183.508 209.109 175.828 215.288 171.533C221.467 167.238 229.674 167.238 235.853 171.533C242.032 175.828 244.874 183.508 242.976 190.779H246.823L254.673 188.826C256.748 188.82 258.429 187.143 258.435 185.073L259.903 178.272C259.903 176.348 258.915 174.768 257.039 174.561C256.027 169.641 248.101 160.653 236.083 159.349L200.628 154.078C200.628 154.078 181.999 142.201 157.106 137.53C157.106 137.53 138.673 133.95 108.333 139.157C108.333 139.157 94.0597 142.574 78.9605 153.564H78.96Z"
        stroke="#001E60"
        stroke-width="4.3937"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ) : (
    <svg
      width="1500"
      height="240"
      viewBox="0 0 1500 240"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_10_8272)">
        <path
          d="M1222.38 101.157C1222.38 89.5844 1213.02 80.2027 1201.47 80.2027C1189.92 80.2027 1180.56 89.5844 1180.56 101.157C1180.56 112.73 1189.92 122.111 1201.47 122.111C1213.02 122.111 1222.38 112.73 1222.38 101.157Z"
          fill="#E4EFF9"
        />
        <path
          d="M1233.07 109.464C1233.07 103.547 1228.28 98.7494 1222.38 98.7494C1216.47 98.7494 1211.69 103.547 1211.69 109.464C1211.69 115.382 1216.47 120.179 1222.38 120.179C1228.28 120.179 1233.07 115.382 1233.07 109.464Z"
          fill="#E4EFF9"
        />
        <path
          d="M1197.54 105.612C1197.54 96.7562 1190.37 89.5773 1181.54 89.5773C1172.7 89.5773 1165.54 96.7562 1165.54 105.612C1165.54 114.467 1172.7 121.646 1181.54 121.646C1190.37 121.646 1197.54 114.467 1197.54 105.612Z"
          fill="#E4EFF9"
        />
        <path
          d="M1180.58 122.476H1244.09C1246.73 122.476 1248.87 120.333 1248.87 117.69C1248.87 115.048 1246.73 112.905 1244.09 112.905H1180.58C1177.94 112.905 1175.8 115.048 1175.8 117.69C1175.8 120.333 1177.94 122.476 1180.58 122.476Z"
          fill="#E4EFF9"
        />
        <path
          d="M1256.89 122.241H1261.07C1263.33 122.241 1265.16 120.408 1265.16 118.148C1265.16 115.887 1263.33 114.054 1261.07 114.054H1256.89C1254.63 114.054 1252.8 115.887 1252.8 118.148C1252.8 120.408 1254.63 122.241 1256.89 122.241Z"
          fill="#E4EFF9"
        />
        <path
          d="M1150.98 123.309H1153.24C1155.5 123.309 1157.32 121.476 1157.32 119.215C1157.32 116.955 1155.5 115.122 1153.24 115.122H1150.98C1148.72 115.122 1146.89 116.955 1146.89 119.215C1146.89 121.476 1148.72 123.309 1150.98 123.309Z"
          fill="#E4EFF9"
        />
        <path
          d="M756.111 183.154C756.111 183.154 777.905 155.852 820.078 155.852C820.078 155.852 853.482 156.709 868.906 146.174C868.906 146.174 886.027 133.275 911.783 142.726C911.783 142.726 951.126 161.627 969.524 156.115C969.524 156.115 1060.1 134.588 1094.63 154.54C1094.63 154.54 1156.05 167.388 1222.28 167.913C1222.28 167.913 1276.62 166.294 1275.77 232.989L743.091 232.464L756.111 185.254"
          fill="#E4EFF9"
        />
        <path
          d="M443.941 86.5445C443.941 133.81 505.856 172.126 582.233 172.126C658.608 172.126 720.524 133.81 720.524 86.5445C720.524 39.2789 658.608 0.962769 582.233 0.962769C505.856 0.962769 443.941 39.2789 443.941 86.5445Z"
          fill="#E4EFF9"
        />
        <path
          d="M285.408 154.201C304.692 200.412 372.427 219.169 436.699 196.097C500.971 173.024 537.441 116.859 518.158 70.6482C498.874 24.4374 431.139 5.6798 366.867 28.752C302.595 51.8247 266.125 107.99 285.408 154.201Z"
          fill="#E4EFF9"
        />
        <path
          d="M224.82 233.777C222.899 197.994 225.941 176.973 234.486 159.995C250.72 127.742 292.676 117.163 321.845 132.783C351.014 148.402 359.194 185.91 340.116 216.559L335.499 233.655L224.82 233.777Z"
          fill="#E4EFF9"
        />
        <path
          d="M1029.38 135.795C1024.16 165.534 1064.63 196.384 1119.77 204.701C1174.9 213.017 1223.83 195.65 1229.04 165.91C1234.26 136.17 1193.79 105.32 1138.65 97.0033C1083.51 88.6874 1034.59 106.055 1029.38 135.795Z"
          fill="#E4EFF9"
        />
        <path
          d="M844.112 118.311C844.112 165.577 909.667 203.893 990.533 203.893C1071.4 203.893 1136.96 165.577 1136.96 118.311C1136.96 71.0457 1071.4 32.7296 990.533 32.7296C909.667 32.7296 844.112 71.0457 844.112 118.311Z"
          fill="#E4EFF9"
        />
        <path
          d="M736.299 112.536C736.299 164.106 788.509 205.912 852.912 205.912C917.315 205.912 969.525 164.106 969.525 112.536C969.525 60.9667 917.315 19.161 852.912 19.161C788.509 19.161 736.299 60.9667 736.299 112.536Z"
          fill="#E4EFF9"
        />
        <path
          d="M677.426 59.5696C677.426 83.7196 700.49 103.297 728.94 103.297C757.39 103.297 780.454 83.7196 780.454 59.5696C780.454 35.4201 757.39 15.8427 728.94 15.8427C700.49 15.8427 677.426 35.4201 677.426 59.5696Z"
          fill="#E4EFF9"
        />
        <path
          d="M553.251 154.64C553.251 191.411 605.765 221.22 670.543 221.22C735.322 221.22 787.835 191.411 787.835 154.64C787.835 117.869 735.322 88.0604 670.543 88.0604C605.765 88.0604 553.251 117.869 553.251 154.64Z"
          fill="#E4EFF9"
        />
        <path
          d="M861.43 231.73L326.854 232.452L366.479 163.858L735.351 100.319L879.441 138.587L861.43 231.73Z"
          fill="#E4EFF9"
        />
        <path
          d="M241.631 227.358L356.91 149.374L381.887 133.007L442.408 135.896L466.424 120.973L521.617 126.315L552.883 114.715L579.012 120.78L637.42 130.6L704.666 123.38L756.541 141.672L785.361 139.747L836.935 170.84L879.505 163.816L917.626 173.727L923.375 179.541L965.175 189.612L1005.52 229.082L811.719 228.36L241.631 227.358Z"
          fill="#C2DCF2"
        />
        <path
          d="M241.631 227.358L356.91 149.374L381.887 133.007L442.408 135.896L466.424 120.973L521.617 126.315L552.883 114.715L579.012 120.78L637.42 130.6L704.666 123.38L756.541 141.672L785.361 139.747L836.935 170.84L879.505 163.816L917.626 173.727L923.375 179.541L965.175 189.612L1005.52 229.082L811.719 228.36L241.631 227.358Z"
          stroke="#C2DCF2"
          stroke-width="7.2049"
          stroke-linecap="round"
        />
        <path
          d="M365.908 143.313C368.457 147.735 359.259 157.837 345.365 165.876C331.472 173.915 318.144 176.847 315.596 172.424C313.049 168.002 322.246 157.9 336.139 149.862C350.033 141.822 363.361 138.89 365.908 143.313Z"
          fill="#C2DCF2"
        />
        <path
          d="M538.77 119.499C541.084 123.515 535.209 131.254 525.648 136.786C516.088 142.318 506.463 143.546 504.149 139.531C501.836 135.516 507.711 127.776 517.271 122.244C526.832 116.713 536.457 115.484 538.77 119.499Z"
          fill="#C2DCF2"
        />
        <path
          d="M637.849 132.687C638.301 137.302 652.859 139.647 670.365 137.926C687.871 136.205 701.697 131.07 701.245 126.455C700.793 121.84 686.235 119.495 668.729 121.216C651.223 122.937 637.398 128.072 637.849 132.687Z"
          fill="#C2DCF2"
        />
        <path
          d="M770.21 181.933H755.258"
          stroke="#9BBEDE"
          stroke-width="1.44098"
          stroke-linecap="round"
        />
        <path
          d="M985 213.823C985 217.248 987.297 220.025 990.131 220.025C992.965 220.025 995.262 217.248 995.262 213.823C995.262 210.398 992.965 207.622 990.131 207.622C987.297 207.622 985 210.398 985 213.823Z"
          fill="#9BBEDE"
        />
        <path
          d="M989.971 218.314V230.247"
          stroke="#9BBEDE"
          stroke-width="1.4112"
          stroke-linecap="round"
        />
        <path
          d="M958.199 226.071H946.39"
          stroke="#9BBEDE"
          stroke-width="1.13789"
          stroke-linecap="round"
        />
        <path
          d="M960.518 224.059H944.844"
          stroke="#9BBEDE"
          stroke-width="1.13789"
          stroke-linecap="round"
        />
        <path
          d="M958.339 221.632H945.898"
          stroke="#9BBEDE"
          stroke-width="1.13789"
          stroke-linecap="round"
        />
        <path
          d="M958.55 219.065H946.671"
          stroke="#9BBEDE"
          stroke-width="1.13789"
          stroke-linecap="round"
        />
        <path
          d="M956.23 216.915H948.217"
          stroke="#9BBEDE"
          stroke-width="1.13789"
          stroke-linecap="round"
        />
        <path
          d="M957.636 214.765H946.812"
          stroke="#9BBEDE"
          stroke-width="1.13789"
          stroke-linecap="round"
        />
        <path
          d="M956.301 212.198H947.936"
          stroke="#9BBEDE"
          stroke-width="1.13789"
          stroke-linecap="round"
        />
        <path
          d="M955.176 209.493H948.991"
          stroke="#9BBEDE"
          stroke-width="1.13789"
          stroke-linecap="round"
        />
        <path
          d="M956.16 207.204H948.217"
          stroke="#9BBEDE"
          stroke-width="1.13789"
          stroke-linecap="round"
        />
        <path
          d="M955.176 204.637H948.569"
          stroke="#9BBEDE"
          stroke-width="1.13789"
          stroke-linecap="round"
        />
        <path
          d="M953.56 201.932H950.818"
          stroke="#9BBEDE"
          stroke-width="1.13789"
          stroke-linecap="round"
        />
        <path
          d="M953.771 199.782H950.186"
          stroke="#9BBEDE"
          stroke-width="1.13789"
          stroke-linecap="round"
        />
        <path
          d="M951.352 197.215H952.394"
          stroke="#9BBEDE"
          stroke-width="1.13789"
          stroke-linecap="round"
        />
        <path
          d="M951.873 197.354V230.518"
          stroke="#9BBEDE"
          stroke-width="1.13789"
          stroke-linecap="round"
        />
        <path
          d="M280.585 181.155H268.776"
          stroke="#9BBEDE"
          stroke-width="1.13789"
          stroke-linecap="round"
        />
        <path
          d="M282.904 179.144H267.229"
          stroke="#9BBEDE"
          stroke-width="1.13789"
          stroke-linecap="round"
        />
        <path
          d="M280.726 176.716H268.284"
          stroke="#9BBEDE"
          stroke-width="1.13789"
          stroke-linecap="round"
        />
        <path
          d="M280.936 174.15H269.057"
          stroke="#9BBEDE"
          stroke-width="1.13789"
          stroke-linecap="round"
        />
        <path
          d="M278.617 171.999H270.603"
          stroke="#9BBEDE"
          stroke-width="1.13789"
          stroke-linecap="round"
        />
        <path
          d="M280.022 169.849H269.198"
          stroke="#9BBEDE"
          stroke-width="1.13789"
          stroke-linecap="round"
        />
        <path
          d="M278.687 167.282H270.323"
          stroke="#9BBEDE"
          stroke-width="1.13789"
          stroke-linecap="round"
        />
        <path
          d="M277.562 164.577H271.376"
          stroke="#9BBEDE"
          stroke-width="1.13789"
          stroke-linecap="round"
        />
        <path
          d="M278.546 162.288H270.604"
          stroke="#9BBEDE"
          stroke-width="1.13789"
          stroke-linecap="round"
        />
        <path
          d="M277.562 159.722H270.955"
          stroke="#9BBEDE"
          stroke-width="1.13789"
          stroke-linecap="round"
        />
        <path
          d="M275.946 157.016H273.205"
          stroke="#9BBEDE"
          stroke-width="1.13789"
          stroke-linecap="round"
        />
        <path
          d="M276.156 154.866H272.572"
          stroke="#9BBEDE"
          stroke-width="1.13789"
          stroke-linecap="round"
        />
        <path
          d="M273.738 152.3H274.78"
          stroke="#9BBEDE"
          stroke-width="1.13789"
          stroke-linecap="round"
        />
        <path
          d="M274.259 152.438V185.603"
          stroke="#9BBEDE"
          stroke-width="1.13789"
          stroke-linecap="round"
        />
        <path
          d="M977.016 225.294H964.283"
          stroke="#9BBEDE"
          stroke-width="1.22723"
          stroke-linecap="round"
        />
        <path
          d="M979.517 223.125H962.615"
          stroke="#9BBEDE"
          stroke-width="1.22723"
          stroke-linecap="round"
        />
        <path
          d="M977.167 220.507H963.752"
          stroke="#9BBEDE"
          stroke-width="1.22723"
          stroke-linecap="round"
        />
        <path
          d="M977.395 217.74H964.586"
          stroke="#9BBEDE"
          stroke-width="1.22723"
          stroke-linecap="round"
        />
        <path
          d="M974.894 215.421H966.253"
          stroke="#9BBEDE"
          stroke-width="1.22723"
          stroke-linecap="round"
        />
        <path
          d="M976.41 213.103H964.738"
          stroke="#9BBEDE"
          stroke-width="1.22723"
          stroke-linecap="round"
        />
        <path
          d="M974.97 210.335H965.95"
          stroke="#9BBEDE"
          stroke-width="1.22723"
          stroke-linecap="round"
        />
        <path
          d="M973.757 207.418H967.087"
          stroke="#9BBEDE"
          stroke-width="1.22723"
          stroke-linecap="round"
        />
        <path
          d="M974.818 204.95H966.253"
          stroke="#9BBEDE"
          stroke-width="1.22723"
          stroke-linecap="round"
        />
        <path
          d="M973.757 202.183H966.632"
          stroke="#9BBEDE"
          stroke-width="1.22723"
          stroke-linecap="round"
        />
        <path
          d="M972.014 199.265H969.058"
          stroke="#9BBEDE"
          stroke-width="1.22723"
          stroke-linecap="round"
        />
        <path
          d="M972.241 196.947H968.376"
          stroke="#9BBEDE"
          stroke-width="1.22723"
          stroke-linecap="round"
        />
        <path
          d="M969.633 194.179H970.756"
          stroke="#9BBEDE"
          stroke-width="1.22723"
          stroke-linecap="round"
        />
        <path
          d="M970.195 194.329V230.179"
          stroke="#9BBEDE"
          stroke-width="1.22723"
          stroke-linecap="round"
        />
        <path
          d="M638.132 174.28H623.181"
          stroke="#9BBEDE"
          stroke-width="1.44098"
          stroke-linecap="round"
        />
        <path
          d="M641.069 171.733H621.223"
          stroke="#9BBEDE"
          stroke-width="1.44098"
          stroke-linecap="round"
        />
        <path
          d="M638.311 168.66H622.558"
          stroke="#9BBEDE"
          stroke-width="1.44098"
          stroke-linecap="round"
        />
        <path
          d="M638.577 165.41H623.537"
          stroke="#9BBEDE"
          stroke-width="1.44098"
          stroke-linecap="round"
        />
        <path
          d="M635.641 162.688H625.495"
          stroke="#9BBEDE"
          stroke-width="1.44098"
          stroke-linecap="round"
        />
        <path
          d="M637.42 159.965H623.715"
          stroke="#9BBEDE"
          stroke-width="1.44098"
          stroke-linecap="round"
        />
        <path
          d="M635.729 156.715H625.139"
          stroke="#9BBEDE"
          stroke-width="1.44098"
          stroke-linecap="round"
        />
        <path
          d="M634.306 153.29H626.474"
          stroke="#9BBEDE"
          stroke-width="1.44098"
          stroke-linecap="round"
        />
        <path
          d="M635.551 150.392H625.495"
          stroke="#9BBEDE"
          stroke-width="1.44098"
          stroke-linecap="round"
        />
        <path
          d="M634.306 147.142H625.94"
          stroke="#9BBEDE"
          stroke-width="1.44098"
          stroke-linecap="round"
        />
        <path
          d="M632.258 143.717H628.787"
          stroke="#9BBEDE"
          stroke-width="1.44098"
          stroke-linecap="round"
        />
        <path
          d="M632.526 140.994H627.987"
          stroke="#9BBEDE"
          stroke-width="1.44098"
          stroke-linecap="round"
        />
        <path
          d="M629.463 137.745H630.782"
          stroke="#9BBEDE"
          stroke-width="1.44098"
          stroke-linecap="round"
        />
        <path
          d="M630.123 137.92V186.839"
          stroke="#9BBEDE"
          stroke-width="1.44098"
          stroke-linecap="round"
        />
        <path
          d="M295.881 188.007H284.548"
          stroke="#9BBEDE"
          stroke-width="1.09226"
          stroke-linecap="round"
        />
        <path
          d="M298.107 186.077H283.064"
          stroke="#9BBEDE"
          stroke-width="1.09226"
          stroke-linecap="round"
        />
        <path
          d="M296.016 183.747H284.076"
          stroke="#9BBEDE"
          stroke-width="1.09226"
          stroke-linecap="round"
        />
        <path
          d="M296.218 181.284H284.818"
          stroke="#9BBEDE"
          stroke-width="1.09226"
          stroke-linecap="round"
        />
        <path
          d="M293.992 179.22H286.302"
          stroke="#9BBEDE"
          stroke-width="1.09226"
          stroke-linecap="round"
        />
        <path
          d="M295.341 177.156H284.953"
          stroke="#9BBEDE"
          stroke-width="1.09226"
          stroke-linecap="round"
        />
        <path
          d="M294.059 174.694H286.032"
          stroke="#9BBEDE"
          stroke-width="1.09226"
          stroke-linecap="round"
        />
        <path
          d="M292.98 172.097H287.044"
          stroke="#9BBEDE"
          stroke-width="1.09226"
          stroke-linecap="round"
        />
        <path
          d="M293.925 169.9H286.302"
          stroke="#9BBEDE"
          stroke-width="1.09226"
          stroke-linecap="round"
        />
        <path
          d="M292.98 167.437H286.639"
          stroke="#9BBEDE"
          stroke-width="1.09226"
          stroke-linecap="round"
        />
        <path
          d="M291.429 164.841H288.797"
          stroke="#9BBEDE"
          stroke-width="1.09226"
          stroke-linecap="round"
        />
        <path
          d="M291.631 162.777H288.191"
          stroke="#9BBEDE"
          stroke-width="1.09226"
          stroke-linecap="round"
        />
        <path
          d="M289.31 160.314H290.31"
          stroke="#9BBEDE"
          stroke-width="1.09226"
          stroke-linecap="round"
        />
        <path
          d="M289.81 160.447V197.527"
          stroke="#9BBEDE"
          stroke-width="1.09226"
          stroke-linecap="round"
        />
        <path
          d="M573.99 179.342H562.657"
          stroke="#9BBEDE"
          stroke-width="1.09226"
          stroke-linecap="round"
        />
        <path
          d="M576.216 177.412H561.173"
          stroke="#9BBEDE"
          stroke-width="1.09226"
          stroke-linecap="round"
        />
        <path
          d="M574.125 175.082H562.185"
          stroke="#9BBEDE"
          stroke-width="1.09226"
          stroke-linecap="round"
        />
        <path
          d="M574.327 172.619H562.927"
          stroke="#9BBEDE"
          stroke-width="1.09226"
          stroke-linecap="round"
        />
        <path
          d="M572.101 170.555H564.411"
          stroke="#9BBEDE"
          stroke-width="1.09226"
          stroke-linecap="round"
        />
        <path
          d="M573.45 168.491H563.062"
          stroke="#9BBEDE"
          stroke-width="1.09226"
          stroke-linecap="round"
        />
        <path
          d="M572.168 166.029H564.141"
          stroke="#9BBEDE"
          stroke-width="1.09226"
          stroke-linecap="round"
        />
        <path
          d="M571.089 163.432H565.153"
          stroke="#9BBEDE"
          stroke-width="1.09226"
          stroke-linecap="round"
        />
        <path
          d="M572.033 161.235H564.41"
          stroke="#9BBEDE"
          stroke-width="1.09226"
          stroke-linecap="round"
        />
        <path
          d="M571.089 158.772H564.748"
          stroke="#9BBEDE"
          stroke-width="1.09226"
          stroke-linecap="round"
        />
        <path
          d="M569.538 156.176H566.907"
          stroke="#9BBEDE"
          stroke-width="1.09226"
          stroke-linecap="round"
        />
        <path
          d="M569.74 154.112H566.299"
          stroke="#9BBEDE"
          stroke-width="1.09226"
          stroke-linecap="round"
        />
        <path
          d="M567.419 151.649H568.419"
          stroke="#9BBEDE"
          stroke-width="1.09226"
          stroke-linecap="round"
        />
        <path
          d="M567.918 151.782V188.862"
          stroke="#9BBEDE"
          stroke-width="1.09226"
          stroke-linecap="round"
        />
        <path
          d="M619.344 173.055H604.392"
          stroke="#9BBEDE"
          stroke-width="1.44098"
          stroke-linecap="round"
        />
        <path
          d="M622.28 170.508H602.434"
          stroke="#9BBEDE"
          stroke-width="1.44098"
          stroke-linecap="round"
        />
        <path
          d="M619.521 167.434H603.769"
          stroke="#9BBEDE"
          stroke-width="1.44098"
          stroke-linecap="round"
        />
        <path
          d="M619.789 164.185H604.748"
          stroke="#9BBEDE"
          stroke-width="1.44098"
          stroke-linecap="round"
        />
        <path
          d="M616.852 161.462H606.706"
          stroke="#9BBEDE"
          stroke-width="1.44098"
          stroke-linecap="round"
        />
        <path
          d="M618.632 158.74H604.926"
          stroke="#9BBEDE"
          stroke-width="1.44098"
          stroke-linecap="round"
        />
        <path
          d="M616.94 155.49H606.35"
          stroke="#9BBEDE"
          stroke-width="1.44098"
          stroke-linecap="round"
        />
        <path
          d="M615.517 152.065H607.685"
          stroke="#9BBEDE"
          stroke-width="1.44098"
          stroke-linecap="round"
        />
        <path
          d="M616.763 149.167H606.706"
          stroke="#9BBEDE"
          stroke-width="1.44098"
          stroke-linecap="round"
        />
        <path
          d="M615.517 145.917H607.151"
          stroke="#9BBEDE"
          stroke-width="1.44098"
          stroke-linecap="round"
        />
        <path
          d="M613.47 142.492H609.999"
          stroke="#9BBEDE"
          stroke-width="1.44098"
          stroke-linecap="round"
        />
        <path
          d="M613.737 139.769H609.198"
          stroke="#9BBEDE"
          stroke-width="1.44098"
          stroke-linecap="round"
        />
        <path
          d="M610.674 136.52H611.993"
          stroke="#9BBEDE"
          stroke-width="1.44098"
          stroke-linecap="round"
        />
        <path
          d="M611.334 136.695V185.614"
          stroke="#9BBEDE"
          stroke-width="1.44098"
          stroke-linecap="round"
        />
        <path
          d="M706.52 162.583H691.568"
          stroke="#9BBEDE"
          stroke-width="1.51543"
          stroke-linecap="round"
        />
        <path
          d="M709.457 159.767H689.61"
          stroke="#9BBEDE"
          stroke-width="1.51543"
          stroke-linecap="round"
        />
        <path
          d="M706.698 156.368H690.945"
          stroke="#9BBEDE"
          stroke-width="1.51543"
          stroke-linecap="round"
        />
        <path
          d="M706.965 152.775H691.924"
          stroke="#9BBEDE"
          stroke-width="1.51543"
          stroke-linecap="round"
        />
        <path
          d="M704.028 149.765H693.882"
          stroke="#9BBEDE"
          stroke-width="1.51543"
          stroke-linecap="round"
        />
        <path
          d="M705.808 146.754H692.102"
          stroke="#9BBEDE"
          stroke-width="1.51543"
          stroke-linecap="round"
        />
        <path
          d="M702.693 150.02H694.861"
          stroke="#9BBEDE"
          stroke-width="1.51543"
          stroke-linecap="round"
        />
        <path
          d="M703.939 146.815H693.882"
          stroke="#9BBEDE"
          stroke-width="1.51543"
          stroke-linecap="round"
        />
        <path
          d="M702.693 143.222H694.327"
          stroke="#9BBEDE"
          stroke-width="1.51543"
          stroke-linecap="round"
        />
        <path
          d="M700.646 139.435H697.175"
          stroke="#9BBEDE"
          stroke-width="1.51543"
          stroke-linecap="round"
        />
        <path
          d="M700.913 136.425H696.374"
          stroke="#9BBEDE"
          stroke-width="1.51543"
          stroke-linecap="round"
        />
        <path
          d="M697.85 132.832H699.169"
          stroke="#9BBEDE"
          stroke-width="1.51543"
          stroke-linecap="round"
        />
        <path
          d="M698.51 133.026V176.47"
          stroke="#9BBEDE"
          stroke-width="1.51543"
          stroke-linecap="round"
        />
        <path
          d="M808.731 191.829H796.466"
          stroke="#9BBEDE"
          stroke-width="1.44098"
          stroke-linecap="round"
        />
        <path
          d="M811.14 189.74H794.859"
          stroke="#9BBEDE"
          stroke-width="1.44098"
          stroke-linecap="round"
        />
        <path
          d="M819.802 207.004H817.953V193.224H819.802V207.004Z"
          fill="#9BBEDE"
        />
        <path
          d="M818.263 196.205L814.558 195.398L813.27 191.847"
          stroke="#9BBEDE"
          stroke-width="0.966417"
        />
        <path
          d="M660.446 143.823C660.446 148.547 663.782 152.376 667.899 152.376C672.015 152.376 675.352 148.547 675.352 143.823C675.352 139.1 672.015 135.271 667.899 135.271C663.782 135.271 660.446 139.1 660.446 143.823Z"
          fill="#9BBEDE"
        />
        <path
          d="M668.506 140.617C668.506 143.342 671.201 145.551 674.526 145.551C677.852 145.551 680.547 143.342 680.547 140.617C680.547 137.892 677.852 135.683 674.526 135.683C671.201 135.683 668.506 137.892 668.506 140.617Z"
          fill="#9BBEDE"
        />
        <path
          d="M671.968 147.238C671.154 148.937 671.775 150.931 673.356 151.692C674.937 152.454 676.879 151.694 677.693 149.996C678.507 148.297 677.886 146.303 676.305 145.542C674.724 144.78 672.783 145.54 671.968 147.238Z"
          fill="#9BBEDE"
        />
        <path
          d="M676.8 144.01C675.986 145.708 676.607 147.703 678.188 148.464C679.769 149.225 681.71 148.466 682.525 146.767C683.339 145.069 682.718 143.075 681.137 142.314C679.556 141.552 677.614 142.312 676.8 144.01Z"
          fill="#9BBEDE"
        />
        <path
          d="M658.923 146.916C658.108 148.614 658.729 150.608 660.31 151.369C661.891 152.131 663.833 151.371 664.647 149.673C665.462 147.974 664.84 145.98 663.259 145.219C661.679 144.458 659.737 145.217 658.923 146.916Z"
          fill="#9BBEDE"
        />
        <path
          d="M656.346 143.203C655.531 144.901 656.153 146.896 657.734 147.657C659.315 148.418 661.256 147.659 662.071 145.96C662.885 144.261 662.264 142.268 660.683 141.506C659.102 140.745 657.16 141.505 656.346 143.203Z"
          fill="#9BBEDE"
        />
        <path
          d="M667.832 134.871C667.018 136.569 667.957 138.716 669.929 139.666C671.903 140.616 674.162 140.009 674.976 138.311C675.79 136.613 674.851 134.466 672.879 133.516C670.906 132.566 668.646 133.172 667.832 134.871Z"
          fill="#9BBEDE"
        />
        <path
          d="M656.785 140.657C656.785 143.019 659.156 144.934 662.081 144.934C665.007 144.934 667.378 143.019 667.378 140.657C667.378 138.294 665.007 136.379 662.081 136.379C659.156 136.379 656.785 138.294 656.785 140.657Z"
          fill="#9BBEDE"
        />
        <path
          d="M660.376 138.784C660.376 141.963 662.549 144.538 665.229 144.538C667.91 144.538 670.083 141.963 670.083 138.784C670.083 135.605 667.91 133.029 665.229 133.029C662.549 133.029 660.376 135.605 660.376 138.784Z"
          fill="#9BBEDE"
        />
        <path
          d="M668.98 165.605H667.13V151.825H668.98V165.605Z"
          fill="#9BBEDE"
        />
        <path
          d="M674.688 150.125L672.433 154.484L668.567 156.097"
          stroke="#9BBEDE"
          stroke-width="0.966417"
        />
        <path
          d="M667.44 154.806L663.736 153.999L662.447 150.448"
          stroke="#9BBEDE"
          stroke-width="0.966417"
        />
        <path
          d="M709.289 159.228C709.289 163.941 712.951 167.762 717.469 167.762C721.987 167.762 725.649 163.941 725.649 159.228C725.649 154.515 721.987 150.694 717.469 150.694C712.951 150.694 709.289 154.515 709.289 159.228Z"
          fill="#9BBEDE"
        />
        <path
          d="M716.082 159.832C716.082 163.734 719.023 166.898 722.652 166.898C726.281 166.898 729.222 163.734 729.222 159.832C729.222 155.93 726.281 152.766 722.652 152.766C719.023 152.766 716.082 155.93 716.082 159.832Z"
          fill="#9BBEDE"
        />
        <path
          d="M712.321 150.142C710.948 152.568 712.53 155.636 715.855 156.993C719.181 158.351 722.99 157.484 724.363 155.056C725.736 152.63 724.153 149.562 720.828 148.205C717.502 146.847 713.694 147.714 712.321 150.142Z"
          fill="#9BBEDE"
        />
        <path
          d="M705.389 158.64C705.389 162.462 707.976 165.56 711.168 165.56C714.361 165.56 716.948 162.462 716.948 158.64C716.948 154.818 714.361 151.719 711.168 151.719C707.976 151.719 705.389 154.818 705.389 158.64Z"
          fill="#9BBEDE"
        />
        <path
          d="M717.764 178.749H715.566V166.005H717.764V178.749Z"
          fill="#9BBEDE"
        />
        <path
          d="M723.353 165.877L720.892 169.907L716.674 171.4"
          stroke="#9BBEDE"
          stroke-width="0.97074"
        />
        <path
          d="M255.372 175.816V195.009"
          stroke="#9BBEDE"
          stroke-width="1.66529"
          stroke-linecap="round"
        />
        <path
          d="M249.506 173.925C249.506 177.967 252.217 181.242 255.561 181.242C258.905 181.242 261.616 177.967 261.616 173.925C261.616 169.883 258.905 166.607 255.561 166.607C252.217 166.607 249.506 169.883 249.506 173.925Z"
          fill="#9BBEDE"
        />
        <path
          d="M583.435 169.558V188.751"
          stroke="#9BBEDE"
          stroke-width="1.66529"
          stroke-linecap="round"
        />
        <path
          d="M577.569 167.667C577.569 171.709 580.28 174.984 583.624 174.984C586.967 174.984 589.678 171.709 589.678 167.667C589.678 163.625 586.967 160.349 583.624 160.349C580.28 160.349 577.569 163.625 577.569 167.667Z"
          fill="#9BBEDE"
        />
        <path
          d="M543.088 176.297V195.49"
          stroke="#9BBEDE"
          stroke-width="1.66529"
          stroke-linecap="round"
        />
        <path
          d="M537.222 174.406C537.222 178.448 539.933 181.724 543.276 181.724C546.62 181.724 549.331 178.448 549.331 174.406C549.331 170.365 546.62 167.089 543.276 167.089C539.933 167.089 537.222 170.365 537.222 174.406Z"
          fill="#9BBEDE"
        />
        <path
          d="M780.009 196.775C780.009 201.438 783.787 205.218 788.447 205.218C793.108 205.218 796.887 201.438 796.887 196.775C796.887 192.112 793.108 188.333 788.447 188.333C783.787 188.333 780.009 192.112 780.009 196.775Z"
          fill="#9BBEDE"
        />
        <path
          d="M734.109 191.32C734.109 195.983 741.467 199.763 750.544 199.763C759.621 199.763 766.979 195.983 766.979 191.32C766.979 186.656 759.621 182.877 750.544 182.877C741.467 182.877 734.109 186.656 734.109 191.32Z"
          fill="#9BBEDE"
        />
        <path
          d="M594.754 190.257C596.277 194.662 603.589 196.124 611.085 193.52C618.58 190.917 623.421 185.235 621.898 180.83C620.375 176.424 613.063 174.963 605.567 177.566C598.072 180.169 593.231 185.851 594.754 190.257Z"
          fill="#9BBEDE"
        />
        <path
          d="M243.172 196.996C244.696 201.401 252.008 202.863 259.503 200.259C266.999 197.656 271.84 191.974 270.317 187.569C268.793 183.163 261.482 181.702 253.986 184.305C246.491 186.908 241.649 192.59 243.172 196.996Z"
          fill="#9BBEDE"
        />
        <path
          d="M653.406 171.517C653.406 176.942 658.178 181.339 664.065 181.339C669.952 181.339 674.724 176.942 674.724 171.517C674.724 166.093 669.952 161.696 664.065 161.696C658.178 161.696 653.406 166.093 653.406 171.517Z"
          fill="#9BBEDE"
        />
        <path
          d="M818.767 208.008C818.767 212.671 822.399 216.45 826.88 216.45C831.36 216.45 834.993 212.671 834.993 208.008C834.993 203.344 831.36 199.565 826.88 199.565C822.399 199.565 818.767 203.344 818.767 208.008Z"
          fill="#9BBEDE"
        />
        <path
          d="M828.707 215.71C828.707 220.373 831.835 224.152 835.693 224.152C839.551 224.152 842.678 220.373 842.678 215.71C842.678 211.047 839.551 207.267 835.693 207.267C831.835 207.267 828.707 211.047 828.707 215.71Z"
          fill="#9BBEDE"
        />
        <path
          d="M791.882 204.798C791.882 209.461 795.01 213.241 798.867 213.241C802.725 213.241 805.853 209.461 805.853 204.798C805.853 200.135 802.725 196.356 798.867 196.356C795.01 196.356 791.882 200.135 791.882 204.798Z"
          fill="#9BBEDE"
        />
        <path
          d="M784.698 137.865C784.698 141.474 787.119 144.4 790.105 144.4C793.091 144.4 795.512 141.474 795.512 137.865C795.512 134.255 793.091 131.33 790.105 131.33C787.119 131.33 784.698 134.255 784.698 137.865Z"
          fill="#C2DCF2"
        />
        <path
          d="M738.267 133.693C738.267 137.302 740.688 140.228 743.674 140.228C746.66 140.228 749.081 137.302 749.081 133.693C749.081 130.083 746.66 127.158 743.674 127.158C740.688 127.158 738.267 130.083 738.267 133.693Z"
          fill="#C2DCF2"
        />
        <path
          d="M799.796 150.526C798.104 154.842 803.369 160.953 811.554 164.175C819.74 167.398 827.746 166.512 829.438 162.196C831.129 157.88 825.865 151.77 817.679 148.547C809.494 145.324 801.488 146.211 799.796 150.526Z"
          fill="#C2DCF2"
        />
        <path
          d="M663.304 166.305C662.599 170.887 670.279 175.877 680.457 177.45C690.634 179.023 699.457 176.583 700.162 172C700.867 167.418 693.188 162.428 683.01 160.855C672.832 159.282 664.009 161.722 663.304 166.305Z"
          fill="#9BBEDE"
        />
        <path
          d="M702.143 177.332C700.95 181.811 708.947 187.84 720.004 190.798C731.062 193.755 740.992 192.521 742.185 188.041C743.378 183.56 735.381 177.531 724.324 174.574C713.266 171.617 703.336 172.851 702.143 177.332Z"
          fill="#9BBEDE"
        />
        <path
          d="M892.531 167.451C890.84 171.766 897.065 178.255 906.434 181.944C915.805 185.633 924.772 185.126 926.464 180.81C928.155 176.494 921.931 170.005 912.561 166.316C903.19 162.627 894.223 163.135 892.531 167.451Z"
          fill="#C2DCF2"
        />
        <path
          d="M850.776 171.514C851.414 176.107 860.014 178.702 869.985 177.311C879.956 175.919 887.522 171.069 886.884 166.477C886.246 161.884 877.646 159.289 867.675 160.68C857.704 162.071 850.138 166.922 850.776 171.514Z"
          fill="#C2DCF2"
        />
        <path
          d="M581.761 121.269C581.077 125.854 587.574 130.628 596.271 131.93C604.969 133.233 612.574 130.571 613.258 125.986C613.942 121.4 607.445 116.626 598.747 115.324C590.049 114.021 582.444 116.683 581.761 121.269Z"
          fill="#C2DCF2"
        />
        <path
          d="M547.658 118.38C546.974 122.966 553.471 127.739 562.168 129.042C570.866 130.345 578.471 127.683 579.155 123.097C579.839 118.511 573.342 113.738 564.644 112.435C555.946 111.133 548.341 113.795 547.658 118.38Z"
          fill="#C2DCF2"
        />
        <path
          d="M663.656 122.3C663.656 125.909 666.416 128.835 669.82 128.835C673.223 128.835 675.983 125.909 675.983 122.3C675.983 118.691 673.223 115.765 669.82 115.765C666.416 115.765 663.656 118.691 663.656 122.3Z"
          fill="#C2DCF2"
        />
        <path
          d="M476.329 119.893C476.329 123.503 479.088 126.428 482.492 126.428C485.896 126.428 488.656 123.503 488.656 119.893C488.656 116.284 485.896 113.358 482.492 113.358C479.088 113.358 476.329 116.284 476.329 119.893Z"
          fill="#C2DCF2"
        />
        <path
          d="M384.675 127.845C384.675 131.455 387.434 134.38 390.838 134.38C394.242 134.38 397.001 131.455 397.001 127.845C397.001 124.236 394.242 121.31 390.838 121.31C387.434 121.31 384.675 124.236 384.675 127.845Z"
          fill="#C2DCF2"
        />
        <path
          d="M374.008 131.64C374.008 135.249 376.767 138.175 380.171 138.175C383.575 138.175 386.335 135.249 386.335 131.64C386.335 128.031 383.575 125.105 380.171 125.105C376.767 125.105 374.008 128.031 374.008 131.64Z"
          fill="#C2DCF2"
        />
        <path
          d="M543.094 115.079C543.094 118.689 545.854 121.614 549.258 121.614C552.661 121.614 555.421 118.689 555.421 115.079C555.421 111.47 552.661 108.544 549.258 108.544C545.854 108.544 543.094 111.47 543.094 115.079Z"
          fill="#C2DCF2"
        />
        <path
          d="M534.231 117.399C534.231 121.008 536.99 123.934 540.395 123.934C543.798 123.934 546.558 121.008 546.558 117.399C546.558 113.789 543.798 110.864 540.395 110.864C536.99 110.864 534.231 113.789 534.231 117.399Z"
          fill="#C2DCF2"
        />
        <path
          d="M725.971 131.446C725.971 135.682 729.686 139.115 734.27 139.115C738.853 139.115 742.569 135.682 742.569 131.446C742.569 127.211 738.853 123.777 734.27 123.777C729.686 123.777 725.971 127.211 725.971 131.446Z"
          fill="#C2DCF2"
        />
        <path
          d="M427.016 134.174C427.016 137.783 429.436 140.709 432.423 140.709C435.409 140.709 437.83 137.783 437.83 134.174C437.83 130.565 435.409 127.639 432.423 127.639C429.436 127.639 427.016 130.565 427.016 134.174Z"
          fill="#C2DCF2"
        />
        <path
          d="M414.719 131.928C414.719 136.163 418.435 139.597 423.018 139.597C427.602 139.597 431.317 136.163 431.317 131.928C431.317 127.692 427.602 124.259 423.018 124.259C418.435 124.259 414.719 127.692 414.719 131.928Z"
          fill="#C2DCF2"
        />
        <path
          d="M691.707 122.14C691.707 125.749 694.874 128.675 698.779 128.675C702.685 128.675 705.851 125.749 705.851 122.14C705.851 118.53 702.685 115.605 698.779 115.605C694.874 115.605 691.707 118.53 691.707 122.14Z"
          fill="#C2DCF2"
        />
        <path
          d="M793.344 143.641C793.344 147.25 795.764 150.176 798.751 150.176C801.737 150.176 804.158 147.25 804.158 143.641C804.158 140.032 801.737 137.106 798.751 137.106C795.764 137.106 793.344 140.032 793.344 143.641Z"
          fill="#C2DCF2"
        />
        <path
          d="M828.646 163.173C828.646 166.782 831.613 169.708 835.273 169.708C838.933 169.708 841.901 166.782 841.901 163.173C841.901 159.564 838.933 156.638 835.273 156.638C831.613 156.638 828.646 159.564 828.646 163.173Z"
          fill="#C2DCF2"
        />
        <path
          d="M851.577 160.649L853.805 156.82C853.52 156.713 853.232 156.545 853.008 156.279C852.761 155.987 852.506 155.469 852.685 154.655C852.698 154.594 852.72 154.537 852.751 154.483L856.302 148.315C856.41 148.127 856.612 148.011 856.831 148.011C857.05 148.011 857.251 148.128 857.36 148.317L861.059 154.778C861.096 154.843 861.121 154.915 861.132 154.988C861.146 155.086 861.259 155.959 860.757 156.536C860.62 156.695 860.394 156.877 860.053 156.959L862.2 160.649C862.308 160.836 862.308 161.066 862.2 161.253L859.808 165.365C859.699 165.552 859.498 165.667 859.28 165.667H854.497C854.279 165.667 854.078 165.552 853.969 165.365L851.577 161.253C851.469 161.066 851.469 160.836 851.577 160.649Z"
          fill="#C2DCF2"
        />
        <path
          d="M772.748 133.511L774.976 129.682C774.691 129.575 774.403 129.407 774.178 129.141C773.932 128.849 773.677 128.331 773.856 127.516C773.869 127.456 773.891 127.398 773.922 127.345L777.473 121.177C777.581 120.989 777.783 120.873 778.002 120.873C778.22 120.873 778.423 120.99 778.531 121.178L782.23 127.64C782.267 127.705 782.292 127.776 782.303 127.85C782.317 127.948 782.43 128.821 781.928 129.398C781.79 129.557 781.565 129.739 781.224 129.82L783.37 133.511C783.479 133.698 783.479 133.928 783.37 134.115L780.979 138.227C780.87 138.414 780.669 138.529 780.451 138.529H775.668C775.45 138.529 775.249 138.414 775.14 138.227L772.748 134.115C772.639 133.928 772.639 133.698 772.748 133.511Z"
          fill="#C2DCF2"
        />
        <path
          d="M759.296 136.501L761.523 132.671C761.239 132.564 760.95 132.397 760.726 132.131C760.48 131.839 760.225 131.321 760.403 130.506C760.416 130.446 760.438 130.388 760.469 130.335L764.02 124.167C764.129 123.979 764.33 123.863 764.549 123.863C764.768 123.863 764.97 123.979 765.078 124.168L768.777 130.63C768.814 130.695 768.839 130.766 768.85 130.84C768.864 130.938 768.978 131.81 768.476 132.388C768.338 132.547 768.113 132.729 767.772 132.81L769.918 136.501C770.027 136.688 770.027 136.918 769.918 137.105L767.526 141.217C767.418 141.404 767.216 141.519 766.999 141.519H762.215C761.998 141.519 761.797 141.404 761.688 141.217L759.296 137.105C759.187 136.918 759.187 136.688 759.296 136.501Z"
          fill="#C2DCF2"
        />
        <path
          d="M715.348 123.022L717.575 119.193C717.291 119.086 717.002 118.919 716.778 118.652C716.532 118.361 716.277 117.843 716.455 117.028C716.468 116.968 716.49 116.91 716.521 116.857L720.073 110.689C720.181 110.501 720.382 110.385 720.601 110.385C720.819 110.385 721.022 110.501 721.13 110.69L724.829 117.152C724.866 117.216 724.891 117.288 724.902 117.362C724.917 117.46 725.03 118.333 724.528 118.91C724.39 119.069 724.165 119.251 723.824 119.332L725.97 123.022C726.079 123.21 726.079 123.44 725.97 123.627L723.578 127.739C723.469 127.926 723.269 128.041 723.051 128.041H718.267C718.05 128.041 717.849 127.926 717.74 127.739L715.348 123.627C715.239 123.44 715.239 123.21 715.348 123.022Z"
          fill="#C2DCF2"
        />
        <path
          d="M634.709 124.502L636.936 120.673C636.652 120.566 636.363 120.399 636.139 120.132C635.893 119.841 635.637 119.323 635.816 118.508C635.829 118.448 635.851 118.39 635.882 118.337L639.433 112.168C639.542 111.98 639.743 111.864 639.962 111.864C640.18 111.865 640.383 111.981 640.491 112.17L644.19 118.632C644.228 118.697 644.252 118.768 644.263 118.842C644.277 118.94 644.391 119.812 643.889 120.39C643.751 120.549 643.526 120.731 643.185 120.812L645.331 124.502C645.44 124.689 645.44 124.92 645.331 125.107L642.939 129.219C642.83 129.406 642.629 129.521 642.412 129.521H637.628C637.411 129.521 637.209 129.406 637.101 129.219L634.709 125.107C634.6 124.92 634.6 124.689 634.709 124.502Z"
          fill="#C2DCF2"
        />
        <path
          d="M623.501 124.181L625.729 120.352C625.444 120.246 625.155 120.078 624.932 119.811C624.685 119.52 624.43 119.002 624.608 118.187C624.621 118.127 624.644 118.069 624.675 118.016L628.226 111.848C628.334 111.66 628.536 111.544 628.755 111.544C628.973 111.544 629.175 111.661 629.284 111.849L632.983 118.311C633.02 118.375 633.044 118.447 633.055 118.521C633.07 118.619 633.183 119.492 632.681 120.069C632.543 120.228 632.318 120.41 631.977 120.491L634.124 124.181C634.232 124.369 634.232 124.599 634.124 124.786L631.732 128.898C631.623 129.085 631.422 129.2 631.204 129.2H626.421C626.203 129.2 626.002 129.085 625.893 128.898L623.501 124.786C623.392 124.599 623.392 124.369 623.501 124.181Z"
          fill="#C2DCF2"
        />
        <path
          d="M575.148 113.912L577.376 110.083C577.091 109.976 576.803 109.808 576.578 109.542C576.332 109.25 576.077 108.732 576.255 107.918C576.268 107.858 576.291 107.8 576.322 107.746L579.873 101.578C579.981 101.39 580.183 101.274 580.401 101.274C580.62 101.274 580.822 101.391 580.931 101.579L584.629 108.042C584.667 108.106 584.691 108.177 584.702 108.251C584.717 108.349 584.83 109.222 584.328 109.8C584.19 109.958 583.965 110.14 583.624 110.222L585.77 113.912C585.879 114.099 585.879 114.329 585.77 114.516L583.379 118.628C583.27 118.815 583.069 118.93 582.851 118.93H578.067C577.85 118.93 577.649 118.815 577.54 118.628L575.148 114.516C575.039 114.329 575.039 114.099 575.148 113.912Z"
          fill="#C2DCF2"
        />
        <path
          d="M488.209 116.961L490.437 113.132C490.152 113.025 489.864 112.857 489.639 112.591C489.393 112.299 489.138 111.781 489.317 110.966C489.329 110.906 489.352 110.849 489.383 110.795L492.934 104.627C493.042 104.439 493.244 104.323 493.462 104.323C493.681 104.323 493.883 104.44 493.992 104.629L497.691 111.09C497.728 111.155 497.752 111.226 497.764 111.3C497.778 111.398 497.891 112.271 497.389 112.848C497.251 113.007 497.026 113.189 496.685 113.27L498.831 116.961C498.94 117.148 498.94 117.378 498.831 117.565L496.44 121.677C496.331 121.864 496.13 121.979 495.912 121.979H491.128C490.911 121.979 490.71 121.864 490.601 121.677L488.209 117.565C488.1 117.378 488.1 117.148 488.209 116.961Z"
          fill="#C2DCF2"
        />
        <path
          d="M405.113 127.551L407.34 123.722C407.056 123.615 406.767 123.447 406.543 123.181C406.297 122.89 406.042 122.371 406.22 121.557C406.233 121.497 406.255 121.439 406.286 121.386L409.837 115.218C409.946 115.029 410.147 114.913 410.366 114.913C410.585 114.913 410.787 115.03 410.895 115.219L414.594 121.681C414.631 121.745 414.656 121.817 414.667 121.89C414.681 121.988 414.795 122.861 414.293 123.439C414.154 123.597 413.93 123.779 413.589 123.861L415.735 127.551C415.844 127.738 415.844 127.968 415.735 128.155L413.343 132.267C413.234 132.454 413.033 132.569 412.816 132.569H408.032C407.815 132.569 407.613 132.454 407.504 132.267L405.113 128.155C405.004 127.968 405.004 127.738 405.113 127.551Z"
          fill="#C2DCF2"
        />
        <path
          d="M357.56 138.142L359.788 134.313C359.503 134.206 359.215 134.038 358.991 133.772C358.744 133.48 358.489 132.962 358.668 132.147C358.681 132.087 358.703 132.029 358.733 131.976L362.285 125.808C362.393 125.62 362.595 125.504 362.814 125.504C363.033 125.504 363.235 125.621 363.343 125.809L367.042 132.271C367.079 132.336 367.104 132.407 367.115 132.481C367.129 132.579 367.242 133.452 366.74 134.029C366.602 134.188 366.377 134.37 366.036 134.451L368.182 138.142C368.291 138.329 368.291 138.559 368.182 138.746L365.791 142.858C365.682 143.045 365.481 143.16 365.263 143.16H360.479C360.262 143.16 360.061 143.045 359.952 142.858L357.56 138.746C357.451 138.559 357.451 138.329 357.56 138.142Z"
          fill="#C2DCF2"
        />
        <path
          d="M843.069 165.16L844.613 162.48C844.416 162.404 844.216 162.286 844.06 162.101C843.89 161.897 843.713 161.534 843.836 160.963C843.846 160.921 843.861 160.881 843.882 160.843L846.344 156.525C846.42 156.393 846.559 156.312 846.711 156.312C846.863 156.312 847.003 156.394 847.078 156.526L849.643 161.05C849.669 161.096 849.685 161.145 849.693 161.197C849.703 161.265 849.782 161.877 849.434 162.281C849.338 162.392 849.182 162.519 848.945 162.577L850.434 165.16C850.509 165.291 850.509 165.452 850.434 165.583L848.775 168.462C848.7 168.593 848.56 168.673 848.41 168.673H845.092C844.942 168.673 844.802 168.593 844.727 168.462L843.069 165.583C842.993 165.452 842.993 165.291 843.069 165.16Z"
          fill="#C2DCF2"
        />
        <path
          d="M876.339 159.461L878.544 155.632C878.263 155.525 877.977 155.357 877.755 155.092C877.511 154.8 877.258 154.282 877.435 153.467C877.448 153.407 877.47 153.349 877.501 153.296L881.017 147.128C881.125 146.94 881.324 146.824 881.541 146.824C881.758 146.824 881.958 146.94 882.065 147.129L885.729 153.591C885.765 153.655 885.79 153.727 885.801 153.801C885.815 153.898 885.927 154.772 885.43 155.349C885.293 155.508 885.07 155.69 884.732 155.771L886.858 159.461C886.966 159.649 886.966 159.879 886.858 160.066L884.489 164.178C884.382 164.365 884.183 164.48 883.967 164.48H879.23C879.014 164.48 878.815 164.365 878.708 164.178L876.339 160.066C876.231 159.879 876.231 159.649 876.339 159.461Z"
          fill="#C2DCF2"
        />
        <path
          d="M889.223 161.579L890.834 158.782C890.628 158.704 890.42 158.582 890.258 158.388C890.08 158.175 889.895 157.796 890.024 157.201C890.034 157.158 890.05 157.116 890.072 157.076L892.64 152.573C892.718 152.435 892.864 152.35 893.022 152.35C893.18 152.35 893.327 152.436 893.405 152.574L896.08 157.292C896.106 157.339 896.125 157.392 896.132 157.445C896.143 157.517 896.225 158.154 895.862 158.576C895.762 158.692 895.599 158.824 895.352 158.884L896.905 161.579C896.984 161.715 896.984 161.883 896.905 162.02L895.175 165.022C895.096 165.159 894.951 165.242 894.794 165.242H891.334C891.177 165.242 891.032 165.159 890.953 165.022L889.223 162.02C889.145 161.883 889.145 161.715 889.223 161.579Z"
          fill="#C2DCF2"
        />
        <path
          d="M749.073 135.263L750.929 132.467C750.692 132.389 750.451 132.266 750.264 132.072C750.06 131.859 749.846 131.481 749.995 130.886C750.006 130.842 750.025 130.8 750.051 130.761L753.008 126.257C753.099 126.119 753.267 126.035 753.449 126.035C753.631 126.035 753.799 126.12 753.89 126.258L756.971 130.976C757.002 131.024 757.022 131.076 757.032 131.13C757.044 131.201 757.138 131.838 756.72 132.26C756.605 132.376 756.418 132.509 756.133 132.569L757.921 135.263C758.012 135.4 758.012 135.568 757.921 135.704L755.929 138.707C755.838 138.843 755.671 138.927 755.49 138.927H751.504C751.323 138.927 751.156 138.843 751.065 138.707L749.073 135.704C748.982 135.568 748.982 135.4 749.073 135.263Z"
          fill="#C2DCF2"
        />
        <path
          d="M705.099 120.18L706.709 117.383C706.504 117.305 706.295 117.183 706.133 116.989C705.955 116.776 705.77 116.397 705.899 115.802C705.909 115.759 705.925 115.717 705.947 115.677L708.515 111.174C708.594 111.036 708.74 110.952 708.897 110.952C709.056 110.952 709.202 111.037 709.28 111.174L711.955 115.893C711.982 115.94 712 115.992 712.008 116.047C712.018 116.118 712.1 116.755 711.737 117.177C711.637 117.293 711.475 117.425 711.228 117.485L712.78 120.18C712.858 120.316 712.858 120.484 712.78 120.621L711.051 123.623C710.972 123.76 710.826 123.844 710.669 123.844H707.21C707.052 123.844 706.907 123.76 706.828 123.623L705.099 120.621C705.02 120.484 705.02 120.316 705.099 120.18Z"
          fill="#C2DCF2"
        />
        <path
          d="M673.24 120.297L674.851 117.502C674.645 117.424 674.436 117.301 674.274 117.107C674.096 116.894 673.911 116.516 674.041 115.921C674.05 115.877 674.066 115.835 674.089 115.796L676.656 111.292C676.735 111.154 676.881 111.069 677.038 111.069C677.196 111.07 677.343 111.155 677.421 111.293L680.096 116.011C680.123 116.058 680.141 116.11 680.149 116.164C680.159 116.236 680.241 116.873 679.878 117.295C679.778 117.411 679.616 117.543 679.369 117.603L680.921 120.297C681 120.434 681 120.602 680.921 120.739L679.192 123.741C679.113 123.877 678.967 123.962 678.81 123.962H675.351C675.193 123.962 675.048 123.877 674.97 123.741L673.24 120.739C673.161 120.602 673.161 120.434 673.24 120.297Z"
          fill="#C2DCF2"
        />
        <path
          d="M612.399 121.581L614.009 118.785C613.804 118.707 613.595 118.585 613.433 118.39C613.255 118.177 613.07 117.799 613.199 117.205C613.208 117.16 613.225 117.118 613.247 117.079L615.815 112.576C615.893 112.438 616.039 112.353 616.197 112.353C616.355 112.354 616.501 112.438 616.58 112.576L619.255 117.295C619.282 117.342 619.299 117.394 619.308 117.448C619.318 117.519 619.4 118.157 619.037 118.578C618.937 118.694 618.774 118.827 618.528 118.887L620.08 121.581C620.158 121.718 620.158 121.886 620.08 122.023L618.35 125.025C618.271 125.161 618.126 125.246 617.969 125.246H614.51C614.352 125.246 614.207 125.161 614.128 125.025L612.399 122.023C612.32 121.886 612.32 121.718 612.399 121.581Z"
          fill="#C2DCF2"
        />
        <path
          d="M551.752 109.327L553.363 106.531C553.157 106.453 552.949 106.331 552.786 106.137C552.609 105.923 552.424 105.545 552.553 104.95C552.563 104.906 552.578 104.864 552.601 104.825L555.169 100.321C555.247 100.184 555.393 100.099 555.551 100.099C555.709 100.1 555.856 100.184 555.934 100.322L558.608 105.04C558.635 105.088 558.654 105.14 558.661 105.194C558.672 105.265 558.753 105.903 558.391 106.324C558.291 106.44 558.128 106.573 557.881 106.633L559.434 109.327C559.512 109.464 559.512 109.632 559.434 109.769L557.704 112.771C557.625 112.907 557.48 112.991 557.323 112.991H553.863C553.706 112.991 553.561 112.907 553.482 112.771L551.752 109.769C551.673 109.632 551.673 109.464 551.752 109.327Z"
          fill="#C2DCF2"
        />
        <path
          d="M501.603 119.335L503.214 116.539C503.008 116.461 502.8 116.338 502.637 116.144C502.46 115.931 502.275 115.553 502.404 114.958C502.414 114.914 502.429 114.872 502.452 114.833L505.02 110.329C505.098 110.191 505.244 110.107 505.402 110.107C505.561 110.107 505.707 110.192 505.785 110.33L508.459 115.048C508.486 115.096 508.505 115.148 508.512 115.202C508.523 115.273 508.605 115.91 508.242 116.332C508.142 116.448 507.979 116.581 507.732 116.64L509.285 119.335C509.363 119.471 509.363 119.639 509.285 119.776L507.555 122.778C507.476 122.915 507.331 122.999 507.174 122.999H503.714C503.557 122.999 503.412 122.915 503.333 122.778L501.603 119.776C501.525 119.639 501.525 119.471 501.603 119.335Z"
          fill="#C2DCF2"
        />
        <path
          d="M446.846 125.111L448.457 122.315C448.251 122.237 448.042 122.115 447.88 121.921C447.702 121.708 447.517 121.33 447.646 120.735C447.656 120.691 447.672 120.648 447.695 120.609L450.262 116.106C450.34 115.968 450.486 115.883 450.644 115.883C450.802 115.884 450.949 115.969 451.027 116.107L453.702 120.825C453.729 120.872 453.747 120.924 453.755 120.978C453.765 121.049 453.847 121.687 453.484 122.108C453.384 122.224 453.221 122.357 452.975 122.417L454.527 125.111C454.606 125.248 454.606 125.416 454.527 125.553L452.798 128.555C452.719 128.691 452.573 128.776 452.416 128.776H448.957C448.799 128.776 448.654 128.691 448.576 128.555L446.846 125.553C446.767 125.416 446.767 125.248 446.846 125.111Z"
          fill="#C2DCF2"
        />
        <path
          d="M437.236 128.845L438.847 126.048C438.641 125.97 438.433 125.848 438.271 125.653C438.093 125.441 437.908 125.062 438.037 124.467C438.047 124.424 438.063 124.382 438.085 124.342L440.653 119.839C440.731 119.701 440.877 119.616 441.035 119.616C441.193 119.616 441.34 119.702 441.418 119.839L444.093 124.558C444.12 124.605 444.137 124.657 444.146 124.711C444.156 124.783 444.238 125.42 443.875 125.842C443.775 125.958 443.612 126.09 443.365 126.15L444.918 128.845C444.996 128.981 444.996 129.149 444.918 129.286L443.188 132.288C443.11 132.425 442.964 132.509 442.807 132.509H439.348C439.19 132.509 439.045 132.425 438.967 132.288L437.236 129.286C437.158 129.149 437.158 128.981 437.236 128.845Z"
          fill="#C2DCF2"
        />
        <path
          d="M914.681 181.476L916.292 178.68C916.086 178.601 915.877 178.479 915.715 178.285C915.537 178.072 915.352 177.694 915.482 177.099C915.491 177.055 915.507 177.013 915.53 176.973L918.097 172.47C918.176 172.332 918.322 172.247 918.48 172.247C918.638 172.247 918.784 172.333 918.863 172.471L921.537 177.189C921.564 177.236 921.582 177.289 921.59 177.342C921.6 177.414 921.682 178.052 921.32 178.473C921.22 178.589 921.057 178.721 920.81 178.781L922.362 181.476C922.441 181.612 922.441 181.78 922.362 181.917L920.633 184.919C920.554 185.056 920.409 185.14 920.251 185.14H916.792C916.634 185.14 916.489 185.056 916.411 184.919L914.681 181.917C914.602 181.78 914.602 181.612 914.681 181.476Z"
          fill="#C2DCF2"
        />
        <path
          d="M233.484 200.454C229.951 207.42 229.771 214.435 233.083 216.122C236.394 217.809 241.943 213.529 245.476 206.563C249.01 199.597 249.189 192.582 245.878 190.895C242.566 189.208 237.017 193.487 233.484 200.454Z"
          fill="#9BBEDE"
        />
        <path
          d="M364.413 85.1081C364.413 79.3555 368.721 74.6924 374.035 74.6924C379.349 74.6924 383.656 79.3555 383.656 85.1081C383.656 90.8601 379.349 95.5233 374.035 95.5233C368.721 95.5233 364.413 90.8601 364.413 85.1081Z"
          fill="#FEFEFE"
        />
        <path
          d="M359.494 89.237C359.494 86.2957 361.697 83.9114 364.414 83.9114C367.131 83.9114 369.333 86.2957 369.333 89.237C369.333 92.1782 367.131 94.5625 364.414 94.5625C361.697 94.5625 359.494 92.1782 359.494 89.237Z"
          fill="#FEFEFE"
        />
        <path
          d="M386.891 89.237C386.891 86.2957 389.094 83.9114 391.81 83.9114C394.528 83.9114 396.73 86.2957 396.73 89.237C396.73 92.1782 394.528 94.5625 391.81 94.5625C389.094 94.5625 386.891 92.1782 386.891 89.237Z"
          fill="#FEFEFE"
        />
        <path
          d="M375.844 87.322C375.844 82.9202 379.14 79.3522 383.206 79.3522C387.272 79.3522 390.568 82.9202 390.568 87.322C390.568 91.7238 387.272 95.2918 383.206 95.2918C379.14 95.2918 375.844 91.7238 375.844 87.322Z"
          fill="#FEFEFE"
        />
        <path
          d="M398.391 96.2433H354.421C352.932 96.2433 351.726 94.9374 351.726 93.3257C351.726 91.7145 352.932 90.4085 354.421 90.4085H398.391C399.88 90.4085 401.086 91.7145 401.086 93.3257C401.086 94.9374 399.88 96.2433 398.391 96.2433Z"
          fill="#FEFEFE"
        />
        <path
          d="M975.291 130.13C975.291 120.153 983.361 112.066 993.315 112.066C1003.27 112.066 1011.34 120.153 1011.34 130.13C1011.34 140.107 1003.27 148.194 993.315 148.194C983.361 148.194 975.291 140.107 975.291 130.13Z"
          fill="#FEFEFE"
        />
        <path
          d="M960.726 134.852C960.726 128.403 965.942 123.176 972.377 123.176C978.811 123.176 984.027 128.403 984.027 134.852C984.027 141.301 978.811 146.528 972.377 146.528C965.942 146.528 960.726 141.301 960.726 134.852Z"
          fill="#FEFEFE"
        />
        <path
          d="M946.845 138.005C946.845 132.944 950.939 128.84 955.989 128.84C961.04 128.84 965.134 132.944 965.134 138.005C965.134 143.067 961.04 147.17 955.989 147.17C950.939 147.17 946.845 143.067 946.845 138.005Z"
          fill="#FEFEFE"
        />
        <path
          d="M996.704 133.97C996.704 126.336 1002.88 120.148 1010.5 120.148C1018.11 120.148 1024.29 126.336 1024.29 133.97C1024.29 141.604 1018.11 147.793 1010.5 147.793C1002.88 147.793 996.704 141.604 996.704 133.97Z"
          fill="#FEFEFE"
        />
        <path
          d="M1011.33 148.508H942.16C939.887 148.508 938.044 146.661 938.044 144.383C938.044 142.104 939.887 140.258 942.16 140.258H1011.33C1013.6 140.258 1015.44 142.104 1015.44 144.383C1015.44 146.661 1013.6 148.508 1011.33 148.508Z"
          fill="#FEFEFE"
        />
        <path
          d="M931.13 148.305H927.521C925.577 148.305 924 146.726 924 144.777C924 142.828 925.577 141.248 927.521 141.248H931.13C933.074 141.248 934.651 142.828 934.651 144.777C934.651 146.726 933.074 148.305 931.13 148.305Z"
          fill="#FEFEFE"
        />
        <path
          d="M1036.84 149.226H1034.89C1032.95 149.226 1031.37 147.646 1031.37 145.698C1031.37 143.749 1032.95 142.169 1034.89 142.169H1036.84C1038.79 142.169 1040.36 143.749 1040.36 145.698C1040.36 147.646 1038.79 149.226 1036.84 149.226Z"
          fill="#FEFEFE"
        />
        <path
          d="M845.395 222.066L824.159 213.647L812.259 207.78L793.133 207.703L776.715 192.069L741.034 196.417L719.223 182.984L675.049 167.346L653.238 177.123L608.512 188.034L584.985 213.928L581.222 223.026C581.222 223.026 582.202 230.519 584.104 230.247C631.176 223.507 797.007 224.308 845.402 224.951C846.161 224.962 845.061 222.11 845.395 222.066Z"
          fill="#9BBEDE"
        />
        <path
          d="M845.395 222.066L824.159 213.647L812.259 207.78L793.133 207.703L776.715 192.069L741.034 196.417L719.223 182.984L675.049 167.346L653.238 177.123L608.512 188.034L584.985 213.928L581.222 223.026C581.222 223.026 582.202 230.519 584.104 230.247C631.176 223.507 797.007 224.308 845.402 224.951C846.161 224.962 845.061 222.11 845.395 222.066Z"
          stroke="#9BBEDE"
          stroke-width="14.2441"
          stroke-linecap="round"
        />
        <path
          d="M231.226 222.891L239.133 204.27L251.692 194.518L266.066 189.248L278.626 190.262L287.786 198.184L293.998 214.392L305.282 224.962C305.282 224.962 305.448 228.023 302.612 228C289.14 227.894 257.386 228.398 231.222 228.837C230.785 228.844 231.418 222.922 231.226 222.891Z"
          fill="#9BBEDE"
        />
        <path
          d="M231.226 222.891L239.133 204.27L251.692 194.518L266.066 189.248L278.626 190.262L287.786 198.184L293.998 214.392L305.282 224.962C305.282 224.962 305.448 228.023 302.612 228C289.14 227.894 257.386 228.398 231.222 228.837C230.785 228.844 231.418 222.922 231.226 222.891Z"
          stroke="#9BBEDE"
          stroke-width="9.20978"
          stroke-linecap="round"
        />
        <path
          d="M500.324 222.891L518.842 204.27L541.404 194.518L567.225 189.248L589.786 190.262L606.241 198.184L631.206 215.836L651.578 224.962C651.578 224.962 557.208 224.455 500.318 224.986C499.532 224.993 500.67 222.922 500.324 222.891Z"
          fill="#9BBEDE"
        />
        <path
          d="M500.324 222.891L518.842 204.27L541.404 194.518L567.225 189.248L589.786 190.262L606.241 198.184L631.206 215.836L651.578 224.962C651.578 224.962 557.208 224.455 500.318 224.986C499.532 224.993 500.67 222.922 500.324 222.891Z"
          stroke="#9BBEDE"
          stroke-width="12.3439"
          stroke-linecap="round"
        />
        <path
          d="M752.95 69.2262C752.95 61.1231 746.882 54.5541 739.396 54.5541C731.911 54.5541 725.843 61.1231 725.843 69.2262C725.843 77.3293 731.911 83.8983 739.396 83.8983C746.882 83.8983 752.95 77.3293 752.95 69.2262Z"
          fill="#FEFEFE"
        />
        <path
          d="M759.88 75.0425C759.88 70.8993 756.777 67.5406 752.95 67.5406C749.122 67.5406 746.02 70.8993 746.02 75.0425C746.02 79.1858 749.122 82.5444 752.95 82.5444C756.777 82.5444 759.88 79.1858 759.88 75.0425Z"
          fill="#FEFEFE"
        />
        <path
          d="M721.287 75.0425C721.287 70.8993 718.184 67.5406 714.356 67.5406C710.529 67.5406 707.426 70.8993 707.426 75.0425C707.426 79.1858 710.529 82.5444 714.356 82.5444C718.184 82.5444 721.287 79.1858 721.287 75.0425Z"
          fill="#FEFEFE"
        />
        <path
          d="M736.848 72.3451C736.848 66.1449 732.205 61.1183 726.477 61.1183C720.75 61.1183 716.106 66.1449 716.106 72.3451C716.106 78.5453 720.75 83.5719 726.477 83.5719C732.205 83.5719 736.848 78.5453 736.848 72.3451Z"
          fill="#FEFEFE"
        />
        <path
          d="M705.087 84.9122H767.027C769.124 84.9122 770.823 83.0724 770.823 80.8027C770.823 78.533 769.124 76.6926 767.027 76.6926H705.087C702.99 76.6926 701.29 78.533 701.29 80.8027C701.29 83.0724 702.99 84.9122 705.087 84.9122Z"
          fill="#FEFEFE"
        />
        <path
          d="M827.472 90.8844C827.472 85.1319 823.164 80.4688 817.85 80.4688C812.537 80.4688 808.229 85.1319 808.229 90.8844C808.229 96.6365 812.537 101.3 817.85 101.3C823.164 101.3 827.472 96.6365 827.472 90.8844Z"
          fill="#FEFEFE"
        />
        <path
          d="M832.392 95.0133C832.392 92.0721 830.189 89.6878 827.472 89.6878C824.755 89.6878 822.552 92.0721 822.552 95.0133C822.552 97.9546 824.755 100.339 827.472 100.339C830.189 100.339 832.392 97.9546 832.392 95.0133Z"
          fill="#FEFEFE"
        />
        <path
          d="M804.995 95.0133C804.995 92.0721 802.792 89.6878 800.075 89.6878C797.358 89.6878 795.156 92.0721 795.156 95.0133C795.156 97.9546 797.358 100.339 800.075 100.339C802.792 100.339 804.995 97.9546 804.995 95.0133Z"
          fill="#FEFEFE"
        />
        <path
          d="M816.042 93.0984C816.042 88.6966 812.745 85.1286 808.68 85.1286C804.614 85.1286 801.318 88.6966 801.318 93.0984C801.318 97.5001 804.614 101.068 808.68 101.068C812.745 101.068 816.042 97.5001 816.042 93.0984Z"
          fill="#FEFEFE"
        />
        <path
          d="M793.495 102.02H837.465C838.954 102.02 840.16 100.714 840.16 99.1021C840.16 97.4909 838.954 96.1849 837.465 96.1849H793.495C792.006 96.1849 790.799 97.4909 790.799 99.1021C790.799 100.714 792.006 102.02 793.495 102.02Z"
          fill="#FEFEFE"
        />
        <path
          d="M534.707 199.756H286.521V194.235H534.707V199.756Z"
          fill="#9BBEDE"
        />
        <path
          d="M442.37 198.352V203.897"
          stroke="#9BBEDE"
          stroke-width="2.94008"
        />
        <path
          d="M365.525 198.352V203.897"
          stroke="#9BBEDE"
          stroke-width="2.94008"
        />
        <path
          d="M477.78 234.579C477.78 217.225 461.395 203.158 441.182 203.158C420.97 203.158 404.584 217.225 404.584 234.579"
          stroke="#9BBEDE"
          stroke-width="3.01021"
          stroke-linecap="round"
        />
        <path
          d="M551.27 234.579C551.27 217.225 534.885 203.158 514.672 203.158C494.46 203.158 478.075 217.225 478.075 234.579"
          stroke="#9BBEDE"
          stroke-width="3.01021"
          stroke-linecap="round"
        />
        <path
          d="M401.958 234.579C401.958 217.225 385.573 203.158 365.361 203.158C345.148 203.158 328.762 217.225 328.762 234.579"
          stroke="#9BBEDE"
          stroke-width="3.01021"
          stroke-linecap="round"
        />
        <path
          d="M328.949 234.579C328.949 217.225 312.563 203.158 292.351 203.158C272.138 203.158 255.752 217.225 255.752 234.579"
          stroke="#9BBEDE"
          stroke-width="3.01021"
          stroke-linecap="round"
        />
        <path
          d="M409.172 230.143H397.369V225.707H409.172V230.143Z"
          fill="#9BBEDE"
        />
        <path
          d="M334.481 230.143H322.678V225.707H334.481V230.143Z"
          fill="#9BBEDE"
        />
        <path
          d="M483.938 230.143H472.135V225.707H483.938V230.143Z"
          fill="#9BBEDE"
        />
        <path
          d="M403.16 197.612V228.295"
          stroke="#9BBEDE"
          stroke-width="2.94008"
        />
        <path
          d="M477.78 197.612V228.295"
          stroke="#9BBEDE"
          stroke-width="2.94008"
        />
        <path
          d="M328.651 197.612V228.295"
          stroke="#9BBEDE"
          stroke-width="2.94008"
        />
        <path
          d="M477.411 197.612L465.976 210.921"
          stroke="#9BBEDE"
          stroke-width="2.94008"
        />
        <path
          d="M402.534 197.612L391.099 210.921"
          stroke="#9BBEDE"
          stroke-width="2.94008"
        />
        <path
          d="M327.97 197.612L316.882 210.51"
          stroke="#9BBEDE"
          stroke-width="2.94008"
        />
        <path
          d="M330.53 197.612L341.965 210.921"
          stroke="#9BBEDE"
          stroke-width="2.94008"
        />
        <path
          d="M404.67 197.612L416.104 210.921"
          stroke="#9BBEDE"
          stroke-width="2.94008"
        />
        <path
          d="M478.441 197.612L489.875 210.921"
          stroke="#9BBEDE"
          stroke-width="2.94008"
        />
        <path
          d="M454.542 196.873L466.561 210.921"
          stroke="#9BBEDE"
          stroke-width="2.94008"
        />
        <path
          d="M428.57 196.873L416.55 210.921"
          stroke="#9BBEDE"
          stroke-width="2.94008"
        />
        <path
          d="M501.259 196.873L489.239 210.921"
          stroke="#9BBEDE"
          stroke-width="2.94008"
        />
        <path
          d="M352.328 196.873L340.308 210.921"
          stroke="#9BBEDE"
          stroke-width="2.94008"
        />
        <path
          d="M380.033 197.243L391.534 210.92"
          stroke="#9BBEDE"
          stroke-width="2.94008"
        />
        <path
          d="M306.383 197.243L317.884 210.92"
          stroke="#9BBEDE"
          stroke-width="2.94008"
        />
        <path
          d="M435.958 237.447H478.085"
          stroke="#001E60"
          stroke-width="5.10638"
          stroke-linecap="round"
        />
        <path
          d="M428.298 237.447C428.298 238.857 427.155 240 425.745 240C424.335 240 423.191 238.857 423.191 237.447C423.191 236.037 424.335 234.894 425.745 234.894C427.155 234.894 428.298 236.037 428.298 237.447Z"
          fill="#001E60"
        />
        <path
          d="M490.851 237.447H602.847H1273.4"
          stroke="#001E60"
          stroke-width="5.10638"
          stroke-linecap="round"
        />
        <path
          d="M226.596 237.447H253.635H415.532"
          stroke="#001E60"
          stroke-width="5.10638"
          stroke-linecap="round"
        />
        {/* <mask id="mask0_10_8272" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="710" y="125" width="245" height="112">
    <path d="M710.066 125H955L952.208 236.68H864.605L824.155 215.105L808.955 192.262L767.519 188.454L720.672 182.743L710.066 125Z" fill="white"/>
    </mask> */}
        <g mask="url(#mask0_10_8272)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M877.915 212.589C877.915 200.168 888.766 187.183 905.07 187.737C917.456 188.157 928.689 200.169 928.689 212.589C928.689 212.666 928.678 212.74 928.677 212.816H930.022L930.053 212.784H935.666C937.921 212.777 939.748 210.946 939.755 208.686V194.125C939.748 192.433 938.707 190.919 937.132 190.311C937.321 172.515 918.101 171.133 918.101 171.133L876.764 165.418L848.134 140.817C798.432 135.698 740.668 139.097 740.668 139.097C732.77 138.749 727.913 149.954 727.913 149.954L720.135 169.261L720.724 189.286C714.017 192.311 718.041 204.077 718.041 204.077C719.048 210.464 724.75 210.8 724.75 210.8L736.996 211.726C737.454 199.709 747.849 188.788 759.944 188.363C776.835 187.773 786.549 200.169 786.549 212.589H877.915H877.915Z"
            fill="white"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M903.618 231.058C894.656 231.058 887.39 223.776 887.39 214.794C887.39 210.48 889.099 206.343 892.143 203.293C895.186 200.243 899.314 198.529 903.618 198.53C912.581 198.53 919.846 205.811 919.846 214.794C919.846 223.776 912.581 231.058 903.618 231.058ZM761.784 231.255C752.822 231.255 745.556 223.973 745.556 214.991C745.556 210.677 747.266 206.54 750.309 203.49C753.352 200.44 757.48 198.726 761.784 198.726C770.747 198.726 778.013 206.008 778.013 214.991C778.013 223.973 770.747 231.255 761.784 231.255Z"
            fill="white"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M725.658 179.807H730.547C733.132 179.799 735.227 177.7 735.234 175.109V174.986C735.227 172.395 733.132 170.296 730.547 170.288H725.658V179.807Z"
            fill="#FF9E16"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M761.056 173.281C760.724 172.967 760.535 172.531 760.533 172.073C760.536 171.145 761.286 170.393 762.212 170.39H770.607C771.533 170.393 772.283 171.145 772.286 172.073C772.284 172.531 772.095 172.967 771.762 173.281C771.748 173.296 771.73 173.306 771.712 173.317C771.697 173.326 771.682 173.334 771.668 173.346C771.543 173.46 771.4 173.554 771.246 173.626C771.043 173.711 770.827 173.756 770.607 173.756H762.212C761.992 173.756 761.775 173.711 761.573 173.626C761.419 173.554 761.276 173.46 761.15 173.346C761.137 173.334 761.122 173.325 761.106 173.316C761.088 173.306 761.071 173.296 761.056 173.281ZM817.764 172.818V172.815V172.815C817.763 172.803 817.76 172.793 817.757 172.782C817.753 172.77 817.75 172.757 817.75 172.744C817.752 171.816 818.502 171.064 819.428 171.061H827.823C828.508 171.058 829.126 171.475 829.381 172.113C829.636 172.751 829.477 173.48 828.978 173.952C828.964 173.966 828.948 173.976 828.931 173.985C828.916 173.994 828.901 174.002 828.889 174.013C828.762 174.129 828.618 174.225 828.461 174.296C828.259 174.382 828.042 174.426 827.823 174.426H819.428C819.209 174.426 818.991 174.382 818.789 174.296C818.635 174.225 818.493 174.131 818.367 174.017C818.353 174.005 818.338 173.996 818.322 173.987C818.305 173.977 818.287 173.966 818.272 173.952C817.964 173.654 817.781 173.247 817.764 172.818Z"
            fill="#001E60"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M931.565 205.231V205.232C931.57 206.957 932.965 208.354 934.686 208.359H936.092V202.104H934.686C932.965 202.109 931.57 203.506 931.565 205.232"
            fill="#FF9E16"
          />
          <path
            d="M939.125 193.297C939.51 193.297 939.823 192.985 939.823 192.599C939.823 192.213 939.51 191.901 939.125 191.901V193.297ZM933.039 191.901C932.653 191.901 932.34 192.213 932.34 192.599C932.34 192.985 932.653 193.297 933.039 193.297V191.901ZM730.617 191.405C731.002 191.405 731.315 191.093 731.315 190.707C731.315 190.322 731.002 190.009 730.617 190.009V191.405ZM720.995 190.009C720.609 190.009 720.297 190.322 720.297 190.707C720.297 191.093 720.609 191.405 720.995 191.405V190.009ZM939.125 191.901H933.039V193.297H939.125V191.901ZM730.617 190.009H720.995V191.405H730.617V190.009Z"
            fill="#001E60"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M745.556 214.991C745.556 223.973 752.822 231.255 761.784 231.255C770.747 231.255 778.013 223.973 778.013 214.991C778.013 206.008 770.747 198.726 761.784 198.726C757.48 198.726 753.352 200.44 750.309 203.49C747.266 206.54 745.556 210.677 745.556 214.991V214.991Z"
            stroke="#001E60"
            stroke-width="6.98113"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M927.784 185.903H929.117C929.756 185.904 930.351 185.575 930.689 185.031C931.027 184.488 931.061 183.808 930.779 183.233C929.337 180.351 927.349 177.582 921.716 176.898C920.902 176.809 920.127 177.268 919.81 178.024C919.494 178.781 919.71 179.656 920.343 180.176C922.207 181.71 924.461 183.596 926.566 185.443C926.903 185.739 927.335 185.903 927.783 185.903H927.784Z"
            fill="#C2DCF3"
          />
          <path
            d="M784.248 188.896C784.5 189.189 784.941 189.222 785.233 188.971C785.525 188.72 785.559 188.279 785.308 187.986L784.248 188.896ZM778.199 180.784L778.728 180.329C778.596 180.175 778.405 180.087 778.203 180.086L778.199 180.784ZM744.803 180.587L744.807 179.889C744.609 179.888 744.421 179.97 744.287 180.116L744.803 180.587ZM737.805 187.204C737.544 187.488 737.564 187.93 737.849 188.19C738.133 188.45 738.575 188.43 738.835 188.146L737.805 187.204ZM928.805 192.924C929.094 193.178 929.535 193.15 929.79 192.86C930.044 192.571 930.016 192.129 929.726 191.875L928.805 192.924ZM916.497 181.178L916.958 180.653C916.836 180.546 916.681 180.485 916.519 180.48L916.497 181.178ZM891.745 180.39L891.767 179.693C891.578 179.687 891.394 179.758 891.258 179.89L891.745 180.39ZM881.534 189.34C881.258 189.609 881.251 190.051 881.52 190.327C881.789 190.604 882.231 190.61 882.507 190.341L881.534 189.34ZM785.308 187.986L778.728 180.329L777.669 181.239L784.248 188.896L785.308 187.986ZM778.203 180.086L744.807 179.889L744.798 181.285L778.195 181.482L778.203 180.086ZM744.287 180.116L737.805 187.204L738.835 188.146L745.318 181.058L744.287 180.116ZM929.726 191.875L916.958 180.653L916.036 181.702L928.805 192.924L929.726 191.875ZM916.519 180.48L891.767 179.693L891.723 181.088L916.475 181.875L916.519 180.48ZM891.258 179.89L881.534 189.34L882.507 190.341L892.231 180.891L891.258 179.89Z"
            fill="#001E60"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M887.39 214.794C887.39 223.776 894.656 231.058 903.618 231.058C912.581 231.058 919.846 223.776 919.846 214.794C919.846 205.811 912.581 198.53 903.618 198.53C899.314 198.529 895.186 200.243 892.143 203.293C889.099 206.343 887.39 210.48 887.39 214.794Z"
            stroke="#001E60"
            stroke-width="6.98113"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M810.897 200.296C810.909 200.682 811.231 200.985 811.616 200.973C812.002 200.961 812.304 200.639 812.292 200.253L810.897 200.296ZM810.612 168.38L811.31 168.359C811.309 168.326 811.306 168.294 811.3 168.261L810.612 168.38ZM807.764 147.786C807.699 147.406 807.337 147.151 806.957 147.217C806.578 147.283 806.323 147.644 806.388 148.024L807.764 147.786ZM763.112 148.206C763.279 147.858 763.132 147.442 762.784 147.275C762.436 147.109 762.019 147.256 761.853 147.604L763.112 148.206ZM753.25 167.199L752.62 166.898C752.578 166.987 752.554 167.085 752.552 167.184L753.25 167.199ZM752.355 176.241C752.347 176.626 752.653 176.945 753.038 176.954C753.424 176.962 753.743 176.656 753.751 176.271L752.355 176.241ZM812.292 200.253L811.31 168.359L809.915 168.402L810.897 200.296L812.292 200.253ZM811.3 168.261L807.764 147.786L806.388 148.024L809.924 168.499L811.3 168.261ZM761.853 147.604L752.62 166.898L753.88 167.5L763.112 148.206L761.853 147.604ZM752.552 167.184L752.355 176.241L753.751 176.271L753.948 167.214L752.552 167.184Z"
            fill="#001E60"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M865.201 167.606L845.512 148.907C845.252 148.659 844.91 148.516 844.552 148.503L812.177 147.322C811.725 147.308 811.291 147.5 810.997 147.845C810.705 148.192 810.589 148.654 810.681 149.099L814.644 168.154C814.785 168.83 815.373 169.318 816.062 169.329L864.163 170.154H864.188C864.791 170.154 865.333 169.786 865.557 169.225C865.78 168.663 865.639 168.022 865.202 167.606H865.201Z"
            fill="#C2DCF3"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M825.052 158.811L814.402 166.987V166.987L813.868 164.421L823.619 156.935C823.952 156.666 824.405 156.599 824.801 156.761C825.198 156.922 825.476 157.286 825.528 157.712C825.58 158.138 825.398 158.558 825.052 158.811ZM817.682 169.16C817.577 169.244 817.448 169.29 817.314 169.29V169.29C817.064 169.29 816.841 169.132 816.758 168.895C816.675 168.659 816.75 168.395 816.945 168.238L825.953 161.019C826.117 160.884 826.341 160.847 826.539 160.924C826.738 161 826.88 161.178 826.911 161.388C826.942 161.599 826.857 161.81 826.69 161.941L817.682 169.16Z"
            fill="#E5F0FA"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M756.869 147.893C756.603 147.459 756.132 147.193 755.624 147.189L739.388 147.074H739.376C738.795 147.074 738.269 147.415 738.031 147.946L730.405 164.985C730.203 165.435 730.24 165.957 730.502 166.375C730.764 166.793 731.217 167.052 731.71 167.065L746.969 167.442L747.008 167.442C747.567 167.442 748.078 167.125 748.327 166.624L756.932 149.325C757.158 148.869 757.134 148.328 756.869 147.894V147.893Z"
            fill="#C2DCF3"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M743.264 147.101L740.078 149.654C739.823 149.858 739.782 150.23 739.986 150.485C740.189 150.74 740.56 150.781 740.814 150.577L745.134 147.115L743.264 147.101V147.101Z"
            fill="#E5F0FA"
          />
          <path
            d="M815.167 168.598L865.626 169.423"
            stroke="#001E60"
            stroke-width="1.39623"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M803.397 148.568C803.296 147.84 802.678 147.298 801.945 147.294L769.262 147.131H769.254C768.689 147.131 768.173 147.455 767.927 147.966L759.201 166.119C758.983 166.572 759.01 167.105 759.273 167.533C759.536 167.961 759.998 168.226 760.5 168.236L804.527 169.084H804.555C804.981 169.084 805.387 168.899 805.666 168.577C805.946 168.255 806.073 167.827 806.014 167.404L803.398 148.568H803.397Z"
            fill="#C2DCF3"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M770.156 152.525L777.132 147.17L780.983 147.19L771.59 154.401C771.255 154.658 770.81 154.716 770.421 154.554C770.032 154.392 769.759 154.035 769.704 153.616C769.65 153.198 769.822 152.782 770.156 152.525ZM777.995 151.821L783.756 147.203L785.631 147.213L778.732 152.743C778.478 152.941 778.112 152.898 777.91 152.646C777.709 152.394 777.747 152.026 777.995 151.821Z"
            fill="#E5F0FA"
          />
          <path
            d="M759.529 166.686C759.144 166.679 758.826 166.985 758.819 167.371C758.812 167.756 759.118 168.075 759.504 168.082L759.529 166.686ZM805.888 168.93C806.274 168.937 806.592 168.63 806.599 168.245C806.606 167.859 806.299 167.541 805.914 167.534L805.888 168.93ZM730.153 165.874C729.768 165.866 729.448 166.172 729.44 166.557C729.432 166.943 729.738 167.262 730.123 167.27L730.153 165.874ZM747.755 166.949V167.647C748.137 167.647 748.449 167.339 748.453 166.957C748.457 166.574 748.152 166.259 747.77 166.251L747.755 166.949ZM747.205 166.251C746.819 166.251 746.507 166.563 746.507 166.949C746.507 167.335 746.819 167.647 747.205 167.647V166.251ZM759.504 168.082L805.888 168.93L805.914 167.534L759.529 166.686L759.504 168.082ZM730.123 167.27L747.74 167.647L747.77 166.251L730.153 165.874L730.123 167.27ZM747.755 166.251H747.205V167.647H747.755V166.251Z"
            fill="#001E60"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M877.915 212.589C877.915 200.168 888.766 187.183 905.07 187.737C917.456 188.157 928.689 200.169 928.689 212.589C928.689 212.666 928.678 212.74 928.677 212.816H930.022L930.053 212.784H935.666C937.921 212.777 939.748 210.946 939.755 208.686V194.125C939.748 192.433 938.707 190.919 937.132 190.311C937.321 172.515 918.101 171.133 918.101 171.133L876.764 165.418L848.134 140.817C798.432 135.698 740.668 139.097 740.668 139.097C732.77 138.749 727.913 149.954 727.913 149.954L720.135 169.261L720.724 189.286C714.017 192.311 718.041 204.077 718.041 204.077C719.048 210.464 724.75 210.8 724.75 210.8L736.996 211.726C737.454 199.709 747.849 188.788 759.944 188.363C776.835 187.773 786.549 200.169 786.549 212.589H877.915H877.915Z"
            stroke="#001E60"
            stroke-width="4.18868"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M604.427 177.748L585.215 178.595C585.215 178.595 574.499 179.834 576.15 199.503C571.382 200.388 572.03 208.738 572.03 208.738V213.439C572.03 218.879 578.493 220.29 578.493 220.29L607.554 224.884C605.187 215.659 608.824 205.938 616.671 200.517C624.519 195.095 634.919 195.117 642.743 200.571C650.568 206.026 654.163 215.762 651.757 224.977H768.399C765.99 215.751 769.597 206.003 777.439 200.553C785.281 195.102 795.696 195.102 803.537 200.553C811.379 206.003 814.987 215.751 812.577 224.977H817.459L827.422 222.499C830.055 222.491 832.189 220.363 832.196 217.736L834.059 209.105C834.059 206.663 832.805 204.658 830.424 204.395C829.14 198.152 819.081 186.744 803.829 185.09L758.834 178.4C758.834 178.4 735.193 163.328 703.601 157.4C703.601 157.4 680.208 152.856 641.704 159.465C641.704 159.465 623.59 163.802 604.427 177.748H604.427Z"
          fill="white"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M790.438 233.516C782.774 233.516 776.562 227.32 776.562 219.674C776.562 216.003 778.024 212.482 780.626 209.886C783.228 207.29 786.758 205.831 790.438 205.832C798.101 205.832 804.313 212.029 804.313 219.674C804.313 227.319 798.101 233.516 790.438 233.516ZM629.38 233.711C621.838 233.711 615.724 227.611 615.724 220.087C615.724 212.563 621.838 206.463 629.38 206.463C636.923 206.463 643.037 212.562 643.037 220.087C643.037 227.611 636.923 233.711 629.38 233.711Z"
          fill="white"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M578.373 196.794H585.022C587.656 196.786 589.789 194.658 589.797 192.031V191.907C589.789 189.28 587.656 187.152 585.022 187.145H579.95C579.463 189.671 578.043 192.826 578.373 196.794V196.794Z"
          fill="#FF9E16"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M822.222 200.736C820.822 197.8 817.395 193.541 809.162 192.553C808.334 192.462 807.549 192.937 807.246 193.71C806.943 194.483 807.198 195.363 807.868 195.856C810.674 197.928 813.39 200.118 816.01 202.42C817.588 203.811 818.804 203.409 820.587 203.355C821.211 203.342 821.786 203.016 822.116 202.488C822.446 201.96 822.486 201.3 822.222 200.736V200.736Z"
          fill="#C2DCF3"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M653.843 188.018H644.043C642.961 188.018 642.083 187.143 642.083 186.063C642.083 184.982 642.961 184.107 644.043 184.107H653.843C654.926 184.107 655.804 184.982 655.804 186.063C655.804 187.143 654.926 188.018 653.843 188.018ZM700.458 189.554C699.377 189.551 698.501 188.677 698.498 187.599C698.501 186.52 699.377 185.646 700.458 185.643H710.259C711.342 185.643 712.22 186.518 712.22 187.598C712.22 188.678 711.342 189.554 710.259 189.554H700.458Z"
          fill="#001E60"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M688.258 179.411L639.742 179.303V179.302C639.274 179.301 638.853 179.019 638.676 178.587C638.498 178.155 638.599 177.659 638.932 177.331L651.142 165.282C651.291 165.135 651.477 165.03 651.68 164.979C661.837 162.462 674.836 162.242 685.685 162.201C686.248 162.2 686.73 162.604 686.824 163.158L689.399 178.063C689.456 178.398 689.363 178.742 689.143 179.002C688.923 179.262 688.599 179.411 688.258 179.411ZM698.34 179.734C698.34 179.734 695.543 165.809 695.099 163.587C694.81 162.145 695.638 162.248 696.263 162.341C727.639 166.989 748.687 180.335 748.687 180.335L698.34 179.734Z"
          fill="#C2DCF3"
        />
        <path
          d="M754.55 216.629H662.083"
          stroke="#001E60"
          stroke-width="1.62274"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M615.724 220.087C615.724 227.611 621.838 233.711 629.38 233.711C636.923 233.711 643.037 227.611 643.037 220.087C643.037 212.562 636.923 206.463 629.38 206.463C621.838 206.463 615.724 212.563 615.724 220.087V220.087Z"
          stroke="#001E60"
          stroke-width="5.37008"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M830.688 207.607H823.479"
          stroke="#001E60"
          stroke-width="1.62274"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M583.222 202.112L577.467 201.492"
          stroke="#001E60"
          stroke-width="1.21998"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M641.083 166.074L626.592 179.497H613.55C613.55 179.497 628.248 168.964 641.083 166.074Z"
          fill="#C2DCF3"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M660.726 168.321L667.76 162.709C668.477 162.66 669.196 162.616 669.915 162.576L661.503 169.288C661.235 169.496 660.849 169.451 660.637 169.186C660.424 168.922 660.464 168.536 660.726 168.321ZM652.466 169.06L659.756 163.489C661.343 163.28 662.934 163.105 664.528 162.963L653.976 171.027C653.624 171.309 653.147 171.379 652.73 171.21C652.312 171.041 652.019 170.659 651.964 170.212C651.909 169.766 652.101 169.325 652.466 169.06Z"
          fill="#E5F0FA"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M776.562 219.674C776.562 227.32 782.774 233.516 790.438 233.516C798.101 233.516 804.313 227.319 804.313 219.674C804.313 212.029 798.101 205.832 790.438 205.832C786.758 205.831 783.228 207.29 780.626 209.886C778.024 212.482 776.562 216.003 776.562 219.674V219.674Z"
          stroke="#001E60"
          stroke-width="5.37008"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M604.647 218.322L579.806 214.605"
          stroke="#001E60"
          stroke-width="1.21998"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M691.084 163.384L695.32 188.997V213.366"
          stroke="#001E60"
          stroke-width="1.46457"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M758.874 179.497V226.17"
          stroke="#001E60"
          stroke-width="0.976378"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M705.975 173.177L698.214 179.106V179.107L697.671 176.401L704.464 171.209C704.817 170.94 705.286 170.879 705.696 171.049C706.106 171.218 706.394 171.593 706.451 172.032C706.509 172.471 706.327 172.908 705.975 173.177ZM707.701 176.46L703.52 179.796L701.561 179.773L706.925 175.493C707.098 175.351 707.334 175.312 707.543 175.393C707.752 175.473 707.901 175.659 707.934 175.88C707.967 176.101 707.878 176.323 707.701 176.46Z"
          fill="#E5F0FA"
        />
        <path
          d="M644.724 167.298C645.004 167.005 644.993 166.542 644.701 166.262C644.409 165.983 643.945 165.993 643.666 166.285L644.724 167.298ZM624.935 186.931L624.406 186.425C624.283 186.554 624.211 186.723 624.203 186.901L624.935 186.931ZM623.996 191.857C623.979 192.261 624.293 192.603 624.697 192.62C625.101 192.636 625.442 192.323 625.459 191.919L623.996 191.857ZM699.592 179.415C699.188 179.41 698.856 179.734 698.851 180.138C698.846 180.543 699.17 180.875 699.574 180.88L699.592 179.415ZM748.679 181.481C749.083 181.485 749.415 181.162 749.42 180.757C749.425 180.353 749.101 180.021 748.697 180.016L748.679 181.481ZM638.805 178.978C638.4 178.977 638.072 179.304 638.071 179.708C638.07 180.113 638.397 180.441 638.801 180.442L638.805 178.978ZM689.63 180.559C690.034 180.56 690.363 180.233 690.364 179.829C690.365 179.424 690.038 179.096 689.633 179.095L689.63 180.559ZM625.35 180.642C625.754 180.642 626.082 180.314 626.082 179.91C626.082 179.506 625.754 179.178 625.35 179.178V180.642ZM612.929 179.178C612.524 179.178 612.196 179.506 612.196 179.91C612.196 180.314 612.524 180.642 612.929 180.642V179.178ZM643.666 166.285L624.406 186.425L625.464 187.438L644.724 167.298L643.666 166.285ZM624.203 186.901L623.996 191.857L625.459 191.919L625.667 186.962L624.203 186.901ZM699.574 180.88L748.679 181.481L748.697 180.016L699.592 179.415L699.574 180.88ZM638.801 180.442L689.63 180.559L689.633 179.095L638.805 178.978L638.801 180.442ZM625.35 179.178H612.929V180.642H625.35V179.178Z"
          fill="#001E60"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M604.427 177.748L585.215 178.595C585.215 178.595 574.499 179.834 576.15 199.503C571.382 200.388 572.03 208.738 572.03 208.738V213.439C572.03 218.879 578.493 220.29 578.493 220.29L607.554 224.884C605.187 215.659 608.824 205.938 616.671 200.517C624.519 195.095 634.919 195.117 642.743 200.571C650.568 206.026 654.163 215.762 651.757 224.977H768.399C765.99 215.751 769.597 206.003 777.439 200.553C785.281 195.102 795.696 195.102 803.537 200.553C811.379 206.003 814.987 215.751 812.577 224.977H817.459L827.422 222.499C830.055 222.491 832.189 220.363 832.196 217.736L834.059 209.105C834.059 206.663 832.805 204.658 830.424 204.395C829.14 198.152 819.081 186.744 803.829 185.09L758.834 178.4C758.834 178.4 735.193 163.328 703.601 157.4C703.601 157.4 680.208 152.856 641.704 159.465C641.704 159.465 623.59 163.802 604.427 177.748H604.427Z"
          stroke="#001E60"
          stroke-width="4.3937"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_10_8272">
          <rect width="1500" height="240" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default CarIllustrationFuelTriage;
